<template>
  <div class="mx-auto my-2">
    <ValidationObserver
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="submit()"
    >
      <v-card class="basil">
        <v-card-title class="text-left justify-left py-6">
          Register New Trainees
        </v-card-title>

        <div class='flex justify-end gap-3 px-4' v-if="isAddNewTraineeTab">
          <v-btn
 v-if="$can('trainee', 'import')"              class="primary white--text rounded-pill"
              depressed
              outlined
              @click="newImport"
          >
            <v-icon left>mdi-import</v-icon>
            <span>New Import</span>
          </v-btn>
        </div>

        <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
          <v-tab v-for="tabItem in tabItems" :key="tabItem">
            {{ tabItem }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
            <div v-if="tabItem === 'Add New Trainee'  && !showForm">
              <v-select
                  v-model="importCategoryType"
                  :items="[{text: 'Category I', value: 'CAT1'}, {text: 'Category II', value: 'CAT2'}]"
                  label="Import category"
                  class="mx-4 mt-4"
                  :disabled="bulkImportLoading || templateDownloadLoading"
                  @change="onImportCategoryChange"
              />
              <v-alert v-if="isCategory1Import" type="info" outlined class="mx-4">
                Register trainees and assign a Category I course. Enter scores, complete, approve and generate certificates on New Trainees Courses after import.
              </v-alert>
              <v-alert
                  border="left"
                  color="blue"
                  colored-border
                  elevation="2"
                  icon="mdi-file-excel"
                  class="mb-5 import-template-banner"
              >
                <div class="d-flex flex-wrap align-center justify-space-between import-template-banner__top">
                  <div class="pr-4">
                    <div class="import-template-title">
                      Start with the official trainee bulk-import template
                    </div>
                    <div class="import-template-subtitle mt-1">
                      Download template, fill <strong>CPD Activity</strong> and <strong>Trainees</strong> sheets, then upload in step 1.
                      You can also upload a Google Form response export and complete CPD Activity in step 2.
                    </div>
                  </div>
                  <div class="mt-2 mt-sm-0 import-template-actions">
                    <div class="import-template-actions__buttons">
                      <v-btn
 v-if="$can('trainee', 'downloadTemplate')"                          color="primary"
                          depressed
                          class="import-template-download-btn"
                          :loading="templateDownloadLoading"
                          :disabled="templateDownloadLoading"
                          @click="downloadTemplate"
                      >
                        <v-icon left>mdi-download</v-icon>
                        {{ templateDownloadLoading ? `Preparing... ${templateDownloadProgress}%` : "Download Template" }}
                      </v-btn>
                      <v-btn
 v-if="$can('trainee', 'downloadTemplate')"                          color="primary"
                          outlined
                          class="import-template-google-btn"
                          @click="downloadGoogleFormTemplate"
                      >
                        <v-icon left>mdi-file-document-outline</v-icon>
                        Google Form Template
                      </v-btn>
                      <v-btn text class="import-template-back-btn" @click="goBack()">Go Back</v-btn>
                    </div>
                    <div v-if="templateDownloadLoading" class="import-template-progress mt-2">
                      <div class="import-template-progress__label">
                        {{ templateDownloadMessage || "Generating template..." }} ({{ templateDownloadProgress }}%)
                      </div>
                      <v-progress-linear
                          :value="templateDownloadProgress"
                          color="primary"
                          height="8"
                          rounded
                      />
                    </div>
                  </div>
                </div>
                <div class="mt-3 import-template-note">
                  Use Step 1 below and complete the substeps in order: download template, then upload completed file.
                </div>
                <div class="import-template-note mt-2">
                  Keep sheet names exactly as <strong>CPD Activity</strong> and <strong>Trainees</strong>; do not modify header row.
                </div>
                <div class="import-template-note mt-2">
                  Google Form export is also supported. Use the Google Form template so exported columns match this importer.
                </div>
                <div v-if="templateDownloadedAt" class="import-template-note success--text mt-1">
                  Last downloaded: {{ formatDownloadTime(templateDownloadedAt) }}
                </div>
              </v-alert>

              <v-stepper v-model="importStep" flat class="bulk-import-stepper">
                <v-stepper-header>
                  <v-stepper-step :complete="importStep > 1" step="1">Download & Upload</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="importStep > 2" step="2">CPD Activity</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="importStep > 3" step="3">Trainees</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step v-if="!isCategory1Import" :complete="importStep > 4" step="4">Completion</v-stepper-step>
                  <v-divider v-if="!isCategory1Import"></v-divider>
                  <v-stepper-step :step="isCategory1Import ? 4 : 5">Confirm</v-stepper-step>
                </v-stepper-header>

                  <v-stepper-items>
                  <v-stepper-content step="1">
                    <div class="import-substeps mb-4">
                      <div class="import-substep" :class="{'is-done': !!templateDownloadedAt}">
                        <div class="import-substep__badge">1</div>
                        <div class="import-substep__body">
                          <div class="import-substep__title">Download Template</div>
                          <div class="import-substep__text">
                            Download the latest bulk-import template before filling trainee/activity data.
                          </div>
                          <div v-if="templateDownloadedAt" class="import-substep__meta success--text">
                            Completed: {{ formatDownloadTime(templateDownloadedAt) }}
                          </div>
                        </div>
                        <v-icon :color="templateDownloadedAt ? 'success' : 'grey lighten-1'">
                          {{ templateDownloadedAt ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                      </div>
                      <div class="import-substep" :class="{'is-done': !!fileName}">
                        <div class="import-substep__badge">2</div>
                        <div class="import-substep__body">
                          <div class="import-substep__title">Upload Completed File</div>
                          <div class="import-substep__text">
                            Use the uploader below to import completed official template or Google Form export.
                          </div>
                          <div v-if="fileName" class="import-substep__meta success--text">
                            Uploaded: {{ fileName }}
                          </div>
                        </div>
                        <v-icon :color="fileName ? 'success' : 'grey lighten-1'">
                          {{ fileName ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                      </div>
                    </div>
                    <div class="import-template-help mb-3">
                      <v-icon small color="primary" class="mr-1">mdi-information-outline</v-icon>
                      <span class="import-template-help__text">
                        Upload the official template (CPD Activity + Trainees) or a Google Form response export with trainee columns.
                      </span>
                    </div>
                    <div class="mb-6 import-upload-card">
                      <upload-excel-component
                          :before-upload="beforeUpload"
                          :on-success="handleSuccess"
                          :parse-all-sheets="true"
                      />
                    </div>
                    <div v-if="fileName" class="selected mb-4">
                      Selected file: {{ fileName }}
                    </div>
                    <v-btn color="primary" :disabled="!canMoveToTrainees" @click="importStep = 2">
                      Next
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <div class="px-4">
                      <v-alert
                          v-if="hasActivityErrors"
                          type="error"
                          dense
                          outlined
                          class="mb-4"
                      >
                        Please complete/fix CPD activity details before proceeding.
                        {{ activityErrors.join(' ') }}
                      </v-alert>
                      <v-card v-if="importActivity" flat class="mb-4 px-2">
                        <v-layout row wrap>
                        <v-flex class="p-2" xs6>
                          <v-select
                              v-model="importActivity.programTypeId"
                              :items="PROGRAM_TYPES"
                              item-text="name"
                              item-value="id"
                              label="CPD Activity Type"
                              :error-messages="activityFormErrors.programTypeId"
                              @change="onActivityChange"
                          ></v-select>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-select
                              v-model="importActivity.categoryId"
                              :items="importCategories"
                              item-text="name"
                              item-value="id"
                              :label="isCategory1Import ? 'CPD Activity (Category I)' : 'CPD Activity (Category II)'"
                              :error-messages="activityFormErrors.categoryId"
                              @change="onActivityCategoryChange"
                          ></v-select>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-select
                              v-model="importActivity.cpdProviderId"
                              :items="CPD_PROVIDERS"
                              :loading="cpdProviderLoading"
                              item-text="trainingCenterName"
                              item-value="id"
                              label="CPD Provider"
                              :disabled="isCpdProviderLocked"
                              :error-messages="activityFormErrors.cpdProviderId"
                              @change="onActivityChange"
                          ></v-select>
                        </v-flex>
                        <v-flex v-if="isCategory1Import" class="p-2" xs6>
                          <v-autocomplete
                              v-model="importActivity.courseId"
                              :items="COURSES"
                              :item-text="courseDisplayName"
                              item-value="id"
                              label="Category I course"
                              :error-messages="activityFormErrors.courseId"
                              @change="onImportCourseChange"
                          />
                        </v-flex>
                        <v-flex v-if="isCategory1Import" class="p-2" xs6>
                          <v-select v-model="importActivity.courseLevelId" :items="importCourseLevels"
                              item-text="name" item-value="id" label="Course level"
                              :error-messages="activityFormErrors.courseLevelId" @change="onActivityChange" />
                        </v-flex>
                        <v-flex v-if="isCategory1Import" class="p-2" xs6>
                          <v-select v-model="importActivity.activityDeliveryId" :items="ACTIVITY_DELIVERIES"
                              item-text="name" item-value="id" label="Activity delivery"
                              :error-messages="activityFormErrors.activityDeliveryId" @change="onActivityChange" />
                        </v-flex>
                        <v-flex v-if="!isCategory1Import" class="p-2" xs6>
                          <v-text-field
                              v-model="importActivity.courseTitleCat2"
                              label="Course Title (Cat2)"
                              :error-messages="activityFormErrors.courseTitleCat2"
                              @input="onActivityChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-combobox
                              v-model="importActivity.facilitatedBy"
                              :items="FACILITATED_BY_OPTIONS"
                              label="Facilitated By"
                              :error-messages="activityFormErrors.facilitatedBy"
                              @change="onActivityChange"
                          ></v-combobox>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-text-field
                              v-model.number="importActivity.participantsNumber"
                              label="Participants Number"
                              type="number"
                              :error-messages="activityFormErrors.participantsNumber"
                              @input="onActivityChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-menu
                              ref="activityStartMenu"
                              v-model="activityStartMenu"
                              :close-on-content-click="false"
                              max-width="290px"
                              min-width="290px"
                              offset-y
                              transition="scale-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="importActivity.startDate"
                                  label="Start Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :error-messages="activityFormErrors.startDate"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="importActivity.startDate"
                                no-title
                                scrollable
                                @input="activityStartMenu = false; onActivityChange()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-menu
                              ref="activityEndMenu"
                              v-model="activityEndMenu"
                              :close-on-content-click="false"
                              max-width="290px"
                              min-width="290px"
                              offset-y
                              transition="scale-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="importActivity.endDate"
                                  label="End Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :error-messages="activityFormErrors.endDate"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="importActivity.endDate"
                                no-title
                                scrollable
                                @input="activityEndMenu = false; onActivityChange()"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-select
                              v-model="importActivity.fundedById"
                              :items="FUNDED_BY"
                              item-text="name"
                              item-value="id"
                              label="Funded By"
                              :error-messages="activityFormErrors.fundedById"
                              @change="onActivityChange"
                          ></v-select>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-text-field
                              v-model.number="importActivity.totalCost"
                              label="Total Cost"
                              type="number"
                              :error-messages="activityFormErrors.totalCost"
                              @input="onActivityChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-text-field
                              v-model="importActivity.color"
                              label="Color"
                              :error-messages="activityFormErrors.color"
                              @input="onActivityChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-text-field
                              v-model="importActivity.expectedOutcome"
                              label="Expected Outcome"
                              @input="onActivityChange"
                          ></v-text-field>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                          <v-combobox
                              v-model="importActivity.collaborator"
                              :items="COLLABORATOR_OPTIONS"
                              label="Collaborator"
                              :error-messages="activityFormErrors.collaborator"
                              @change="onActivityChange"
                              clearable
                          ></v-combobox>
                        </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card v-if="!isCategory1Import" flat outlined class="mb-4 px-4 py-3">
                        <div class="text-subtitle-2 mb-3">
                          Default Cat II values for all trainees
                        </div>
                        <div class="text-body-2 mb-3">
                          Cat II role options load from the selected CPD Activity. Set the default role and multiplier here, then the trainee rows will inherit them in the next step.
                        </div>
                        <v-layout row wrap>
                          <v-flex class="p-2" xs12 md6>
                            <v-select
                                v-model="traineeDefaults.cat2Role"
                                :items="catIIRoleOptions"
                                :loading="catIILoading"
                                :disabled="!importActivity || !importActivity.categoryId"
                                clearable
                                label="Default Cat II Role"
                                hint="Select CPD Activity first to load Cat II roles"
                                persistent-hint
                                @change="onDefaultCat2RoleChange"
                            ></v-select>
                          </v-flex>
                          <v-flex class="p-2" xs12 md6>
                            <v-text-field
                                v-model.number="traineeDefaults.cat2MultiplierValue"
                                :disabled="!requiresCat2Multiplier(traineeDefaults.cat2Role)"
                                clearable
                                label="Default Multiplier Value"
                                type="number"
                                @input="onDefaultCat2MultiplierChange"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </div>
                    <div class="mt-4">
                      <v-btn text @click="importStep = 1">Back</v-btn>
                      <v-btn
                          color="primary"
                          :disabled="hasActivityErrors || !importActivity"
                          @click="importStep = 3"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <div class="px-4">
                      <v-alert
                          v-if="hasTraineeErrors"
                          type="error"
                          dense
                          outlined
                          class="mb-4"
                      >
                        <div class="font-semibold">
                          Please fix the trainee sheet errors before proceeding.
                          Click an error to jump to the cell.
                        </div>
                        <div class="mt-2">
                          <v-chip
                              v-for="(err, index) in traineeErrorDetails"
                              :key="`${err.row}-${err.field}-${index}`"
                              class="ma-1"
                              color="red lighten-4"
                              text-color="red darken-3"
                              small
                              @click="goToTraineeError(err)"
                          >
                            Row {{ err.row }} · {{ traineeFieldLabel(err.field) }} — {{ err.message }}
                          </v-chip>
                        </div>
                      </v-alert>
                      <v-alert
                          v-if="!isCategory1Import && traineeDefaults.cat2Role"
                          type="info"
                          dense
                          outlined
                          class="mb-4"
                      >
                        Default trainee Cat II role: <strong>{{ traineeDefaults.cat2Role }}</strong>
                        <span v-if="traineeDefaults.cat2MultiplierValue !== null && traineeDefaults.cat2MultiplierValue !== ''">
                          · Multiplier: <strong>{{ traineeDefaults.cat2MultiplierValue }}</strong>
                        </span>
                      </v-alert>
                      <v-data-table
                          v-if="csvResults.length"
                          :headers="importTraineeHeaders"
                          :items="csvResults"
                          :options.sync="previewOptions"
                          class="elevation-1"
                          loading-text="Loading... please wait"
                          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 20, 50] }"
                      >
                        <template v-slot:item.prefix="{ item }">
                          <v-select
                              v-model="item.prefix"
                              :items="prefixes"
                              item-text="name"
                              item-value="name"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'prefix')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.firstName="{ item }">
                          <v-text-field
                              v-model="item.firstName"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'firstName')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.fatherName="{ item }">
                          <v-text-field
                              v-model="item.fatherName"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'fatherName')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.grandfatherName="{ item }">
                          <v-text-field
                              v-model="item.grandfatherName"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'grandfatherName')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.gender="{ item }">
                          <v-select
                              v-model="item.gender"
                              :items="['Male','Female']"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'gender')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.profession="{ item }">
                          <v-select
                              v-model="item.profession"
                              :items="professionNames"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'profession')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.region="{ item }">
                          <v-select
                              v-model="item.region"
                              :items="regionNames"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'region')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.zone="{ item }">
                          <v-select
                              v-model="item.zone"
                              :items="getRowZoneOptions(item)"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'zone')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.woreda="{ item }">
                          <v-select
                              v-model="item.woreda"
                              :items="getRowWoredaOptions(item)"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'woreda')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.facility="{ item }">
                          <v-select
                              v-model="item.facility"
                              :items="getRowFacilityOptions(item)"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'facility')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.cat2Role="{ item }">
                          <v-select
                              v-model="item.cat2Role"
                              :items="catIIRoleOptions"
                              :loading="catIILoading"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'cat2Role')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.cat2MultiplierValue="{ item }">
                          <v-text-field
                              v-model.number="item.cat2MultiplierValue"
                              :disabled="!requiresCat2Multiplier(item.cat2Role)"
                              dense
                              hide-details
                              type="number"
                              :id="cellId(item.__rowIndex, 'cat2MultiplierValue')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.ceu="{ item }">
                          <v-text-field
                              :value="item.ceu"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'ceu')"
                              readonly
                          />
                        </template>
                        <template v-slot:item.kebele="{ item }">
                          <v-text-field
                              v-model="item.kebele"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'kebele')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.unemployed="{ item }">
                          <v-select
                              v-model="item.unemployed"
                              :items="['Yes','No']"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'unemployed')"
                              @change="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.emailAddress="{ item }">
                          <v-text-field
                              v-model="item.emailAddress"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'emailAddress')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.phoneNumber="{ item }">
                          <v-text-field
                              v-model="item.phoneNumber"
                              dense
                              hide-details
                              type="tel"
                              inputmode="numeric"
                              maxlength="13"
                              placeholder="+2519xxxxxxx"
                              :id="cellId(item.__rowIndex, 'phoneNumber')"
                              @input="onBulkPhoneInput(item, $event)"
                          />
                        </template>
                        <template v-slot:item.employeeId="{ item }">
                          <v-text-field
                              v-model="item.employeeId"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'employeeId')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.licenseNumber="{ item }">
                          <v-text-field
                              v-model="item.licenseNumber"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'licenseNumber')"
                              @input="onTraineeEdit"
                          />
                        </template>
                        <template v-slot:item.nationalId="{ item }">
                          <v-text-field
                              v-model="item.nationalId"
                              dense
                              hide-details
                              :id="cellId(item.__rowIndex, 'nationalId')"
                              @input="onTraineeEdit"
                          />
                        </template>
                      </v-data-table>
                    </div>
                    <div class="mt-4">
                      <v-btn text @click="importStep = 2">Back</v-btn>
                      <v-btn
                          color="primary"
                          :disabled="hasTraineeErrors || !csvResults.length"
                          @click="importStep = 4"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content v-if="!isCategory1Import" step="4">
                    <div class="px-4">
                      <v-layout row wrap>
                        <v-flex class="p-2" xs6>
                        <v-menu
                            ref="completionMenu"
                            v-model="completionMenu"
                            :close-on-content-click="false"
                            max-width="290px"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="completion.courseCompletionDate"
                                :clearable="true"
                                label="Completion date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="completion.courseCompletionDate"
                              no-title
                              scrollable
                              @input="completionMenu = false"
                          ></v-date-picker>
                        </v-menu>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                        <v-autocomplete
                            v-model="completion.certificateReason"
                            :items="CERTIFICATE_REASONS"
                            :loading="certReasonLoading"
                            item-text="name"
                            item-value="id"
                            label="Certificate reason"
                            clearable
                        ></v-autocomplete>
                        </v-flex>
                        <v-flex class="p-2" xs6>
                        <v-text-field
                            label="Status"
                            value="PASS"
                            readonly
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div class="mt-4">
                      <v-btn text @click="importStep = 3">Back</v-btn>
                      <v-btn
                          color="primary"
                          :disabled="!isCompletionValid"
                          @click="importStep = 5"
                      >
                        Next
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content :step="isCategory1Import ? 4 : 5">
                    <v-alert type="info" outlined class="mb-4 text-subtitle-1 py-4">
                      <template v-if="isCategory1Import">
                        This will create the Category I CPD activity, register or reuse trainees, and assign the selected course.
                        Scores, completion, approval and certificates will be handled on New Trainees Courses.
                      </template>
                      <template v-else>
                        This will create the CPD activity (Category II), register all trainees,
                        mark them as completed (PASS), and assign the activity to each trainee.
                      </template>
                    </v-alert>
                    <v-simple-table v-if="isCategory1Import && importActivity" class="mb-4">
                      <tbody>
                        <tr v-for="row in activityPreviewRows" :key="row.label"><th>{{ row.label }}</th><td>{{ row.value }}</td></tr>
                        <tr><th>Trainees to register / assign</th><td>{{ importedData.length }}</td></tr>
                      </tbody>
                    </v-simple-table>
                    <div class="mb-4" v-if="bulkProgress.total">
                      Processing: {{ bulkProgress.current }} / {{ bulkProgress.total }}
                      <v-progress-linear
                          :value="bulkProgressPercent"
                          height="6"
                          rounded
                      ></v-progress-linear>
                    </div>
                    <v-btn
                        color="primary"
                        :loading="bulkImportLoading"
                        :disabled="bulkImportLoading || bulkImportedUpdates.length > 0 || hasTraineeErrors || hasActivityErrors || !isCompletionValid"
                        @click="processBulkImport"
                    >
                      {{ isCategory1Import ? 'Register & Assign' : 'Complete' }}
                    </v-btn>
                    <v-btn text :disabled="bulkImportLoading" @click="importStep = isCategory1Import ? 3 : 4">Back</v-btn>
                    <v-btn v-if="isCategory1Import && bulkImportedUpdates.length" color="secondary" class="ml-2"
                        @click="$router.push({name: 'Trainee', params: {fromRoute: 'Add'}})">
                      Open New Trainees Courses
                    </v-btn>
                    <v-btn
                        v-if="$can('trainee', 'downloadCertificates') && (!isCategory1Import && bulkImportedUpdates.length)"
                        color="secondary"
                        class="ml-2"
                        :loading="bulkCertificateLoading"
                        :disabled="bulkImportLoading || bulkCertificateLoading || !areBulkImportedCertificatesApproved"
                        @click="generateCertificatesBatch(bulkImportedUpdates, 'download')"
                    >
                      Generate Certificate
                    </v-btn>
                    <v-btn
                        v-if="$can('trainee', 'emailCertificate') && (!isCategory1Import && bulkImportedUpdates.length)"
                        color="secondary"
                        class="ml-2"
                        outlined
                        :loading="bulkCertificateLoading"
                        :disabled="bulkImportLoading || bulkCertificateLoading || !areBulkImportedCertificatesApproved"
                        @click="generateCertificatesBatch(bulkImportedUpdates, 'email')"
                    >
                      Generate Certificate & Send Email
                    </v-btn>
                    <v-alert
                        v-if="!isCategory1Import && bulkImportedUpdates.length && !areBulkImportedCertificatesApproved"
                        type="info"
                        dense
                        outlined
                        class="mt-4"
                    >
                      {{ bulkImportedPendingApprovalCount }} imported trainee certificate(s) still require approval.
                      All imported trainees must complete certificate approval before certificates can be printed or emailed.
                    </v-alert>
                    <v-alert
                        v-if="bulkImportMessage"
                        type="success"
                        dense
                        outlined
                        class="mt-4"
                    >
                      {{ bulkImportMessage }}
                    </v-alert>
                    <v-alert
                        v-if="bulkImportErrors.length"
                        type="warning"
                        dense
                        outlined
                        class="mt-4"
                    >
                      {{ bulkImportErrors.join(' ') }}
                    </v-alert>
                    <v-alert
                        v-if="bulkCertificateErrors.length"
                        type="warning"
                        dense
                        outlined
                        class="mt-4"
                    >
                      {{ bulkCertificateErrors.join(' ') }}
                    </v-alert>
                    <v-alert
                        v-if="bulkImportWarnings.length"
                        type="warning"
                        dense
                        outlined
                        class="mt-4"
                    >
                      {{ bulkImportWarnings.length }} existing trainee record(s) were reused.
                      <v-btn small text color="warning" @click="bulkImportWarningsDialog = true">
                        View Details
                      </v-btn>
                    </v-alert>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
              <importErrorModal
                  :dialogState="importErrorsDialog"
                  :importErrors="importErrors"
                  @dialogEvent="() =>importErrorsDialog = false"
              ></importErrorModal>
              <v-dialog v-model="bulkImportWarningsDialog" max-width="900">
                <v-card>
                  <v-card-title class="text-h5 bulk-import-warning-header">
                    <div>
                      <div class="bulk-import-warning-title">Existing trainees reused</div>
                      <div class="bulk-import-warning-subtitle">
                        The import continued and assigned this CPD activity to the existing trainee records.
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-chip color="warning" outlined>
                      {{ bulkImportWarnings.length }} warning(s)
                    </v-chip>
                    <v-btn color="black" text @click="bulkImportWarningsDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="mt-4">
                    <v-list two-line>
                      <v-list-item
                          v-for="(message, index) in bulkImportWarnings"
                          :key="index"
                      >
                        <v-list-item-icon>
                          <v-icon color="warning">mdi-alert-circle-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="bulk-import-warning-message">
                            {{ message }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="bulkImportWarningsDialog = false">
                      Continue
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <div v-if="tabItem === 'Add New Trainee'  && showForm">
              <div class="w-full flex cpd-provider-form__shell">
                <v-card
                    class="mx-auto w-full"
                    flat
                    max-height="auto"
                    max-width="1000"
                >
                  <v-divider></v-divider>

                  <div class="flex flex-wrap cpd-provider-form__grid">
                    <div class="w-full md:w-1/2 px-3 pt-3 mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Prefix</label
                      >
                      <v-select
                          v-model="formValues.prefix"
                          :elevation="1"
                          :items="prefixes"
                          dense
                          item-text="name"
                          item-value="name"
                          label="prefix"
                          solo
                      ></v-select>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required mt-3">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >First Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="firstName"
                            v-model="formValues.firstName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Father Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="middleName"
                            v-model="formValues.middleName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Grandfather Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="lastName"
                            v-model="formValues.lastName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Gender</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <input
                            id="Male"
                            v-model="formValues.gender"
                            class="my-3 ml-5"
                            type="radio"
                            value="Male"
                        />
                        <label for="Male"> Male </label>
                        <br/>

                        <input
                            id="Female"
                            v-model="formValues.gender"
                            class="my-3 ml-5"
                            type="radio"
                            value="Female"
                        />
                        <label for="Female"> Female </label>
                        <br/>
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Proffesion</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-select
                            v-model="formValues.healthProfessionId"
                            :elevation="1"
                            :items="PROFESSIONS"
                            :loading="professionLoading"
                            dense
                            item-text="name"
                            item-value="id"
                            solo
                        ></v-select>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Region</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-select
                            v-model="defaultRegion"
                            :elevation="1"
                            :items="REGIONS"
                            :loading="regionLoading"
                            dense
                            item-text="name"
                            item-value="id"
                            return-object
                            solo
                            @change="regionOnChange($event)"
                        >
                        </v-select>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Zone</label
                      >

                      <v-autocomplete
                          v-model="defaultZone"
                          :clearable="true"
                          :elevation="1"
                          :items="FILTERED_ZONES"
                          :loading="zoneLoading"
                          dense
                          item-text="name"
                          item-value="id"
                          return-object
                          solo
                          @change="zoneOnChange($event)"
                      >
                      </v-autocomplete>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Woreda</label
                      >

                      <v-autocomplete
                          v-model="formValues.woredaId"
                          :clearable="true"
                          :elevation="1"
                          :items="FILTERED_WOREDAS"
                          :loading="woredaLoading"
                          dense
                          item-text="name"
                          item-value="id"
                          return-object
                          solo
                          @change="woredaOnChange($event)"
                      >
                      </v-autocomplete>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Kebele</label
                      >

                      <input
                          id="kebele"
                          v-model="formValues.kebele"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <v-checkbox v-model="formValues.unemployed" style="float: left; text-align: left; margin-top: 0;"
                                  @change="unemployedChanged()"></v-checkbox>
                      Unemployed?
                    </div>
                    <div v-if="!formValues.unemployed" class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Facility</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="formValues.facilityId"
                            :clearable="clearable"
                            :elevation="1"
                            :items="NEW_TRAINEE_FACILITIES"
                            :loading="facilityLoading"
                            :searchable="searchable"
                            dense
                            hint="Search facility name or unique code"
                            :item-text="getFacilityDisplayText"
                            item-value="id"
                            persistent-hint
                            return-object
                            solo
                            @change="facilityOnChange($event)"
                        >
                        </v-autocomplete>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Email Address</label
                      >
                      <validation-provider v-slot="{ errors }" rules="email">
                        <input
                            id="facilityEmail"
                            v-model="formValues.facilityEmail"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="email"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Phone number</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          mode="eager"
                          :rules="{
                          required: true,
                          phone_regex:
                            '^\\+251[97]\\d{8}$',
                        }"
                      >
                        <input
                            id="phoneNumber"
                            v-model="formValues.phoneNumber"
                            inputmode="numeric"
                            maxlength="13"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            placeholder="+2519xxxxxxx"
                            type="tel"
                            @input="onPhoneInput('phoneNumber', $event.target.value, true)"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Employee Id</label
                      >

                      <input
                          id="employeeId"
                          v-model="formValues.employeeId"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >License number</label
                      >

                      <input
                          id="licenseNumber"
                          v-model="formValues.licenseNumber"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 mt-2">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2"
                      >National ID</label
                      >

                      <input
                          id="licenseNumber"
                          v-model="formValues.national_id"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                  </div>

                  <div class="flex flex-wrap cpd-provider-form__actions">
                    <div class="w-full">
                      <v-btn
                          class="cpd-provider-form__back"
                          @click="backToTrainee()"
                      >
                        <v-icon dark left> mdi-arrow-left</v-icon>
                        Back
                      </v-btn>
                      <button
                          class="cpd-provider-form__submit"
                          type="button"
                          @click="submit()"
                      >
                        Add Trainee
                      </button>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <div v-if="tabItem === 'New Trainee History'">
              <v-text-field
                  v-model="searchNewTrainee"
                  append-icon="mdi-magnify"
                  hide-details
                  label="Search"
                  single-line
                  style="padding: 6px 31px; width: 35%"
              ></v-text-field>
              <v-card class="mx-4" flat>
                <v-data-table
                    :headers="newTraineeheaders"
                    :items="newTrainees.rows"
                    :loading="loading"
                    :options.sync="options"
                    :server-items-length="newTrainees.count"
                    class="elevation-1"
                    loading-text="Loading... please wait">
                  >
                  <template v-slot:[`item.fullName`]="{ item }">
                    <label for="item">
                      {{ item?.prefix }}
                      {{ item?.firstName }} {{ item?.middleName }} {{ item?.lastName }}
                    </label>
                  </template>
                  <template v-slot:[`item.location`]="{ item }">
                    <label for="item">{{ item?.woreda?.name ?? item?.facility?.woreda?.name }}</label>
                  </template>
                  <template v-slot:[`item.verificationStatus`]="{ item }">
                    <v-chip
                        :color="verificationStatusColor(item.verificationStatus)"
                        dark
                        small
                    >
                      {{ verificationStatusLabel(item.verificationStatus) }}
                    </v-chip>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip v-if="item.canEditTrainee !== false" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                            class="mr-2"
                            style="color: teal"
                            @click="editNewTrainee(item)"
                            v-on="on"
                        >mdi-circle-edit-outline
                        </v-icon
                        >
                      </template>
                      <span>Edit New Trainee</span>
                    </v-tooltip>
                    <v-tooltip v-if="canReviewTrainee(item)" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
 v-if="$can('trainee', 'verify')"                            class="mr-2"
                            color="success"
                            @click="reviewTrainee(item, 'verify')"
                            v-on="on"
                        >mdi-account-check-outline
                        </v-icon>
                      </template>
                      <span>Verify Trainee</span>
                    </v-tooltip>
                    <v-tooltip v-if="canReviewTrainee(item)" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
 v-if="$can('trainee', 'reject')"                            class="mr-2"
                            color="error"
                            @click="reviewTrainee(item, 'reject')"
                            v-on="on"
                        >mdi-account-cancel-outline
                        </v-icon>
                      </template>
                      <span>Reject Trainee</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>

              <template>
                <v-dialog v-model="editDialog" persistent width="60%">
                  <v-card>
                    <v-card-title
                        class="headline font-weight-regular blue-grey white--text"
                        primary-title
                    >{{ title }}

                      <v-spacer></v-spacer>

                      <v-btn color="white" text @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title
                    >

                    <v-divider></v-divider>
                    <HrdNewTraineeEdit
                        v-if="editDialog"
                        :newTrainee="newTrainee"
                        @close="closeDialog()"
                        @updateTrainee="updateTrainee"
                    ></HrdNewTraineeEdit>
                  </v-card>
                </v-dialog>
              </template>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import {accessPolicy} from "@/utils/managedAccess";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {isValidEthiopianPhone, normalizeEthiopianPhone} from "@/utils/phone";
import {email, regex, required} from "vee-validate/dist/rules";
import {
  getFacilitiesByWoredaId,
  getHealthProfessions,
  getRegionList,
  getWoredaByZoneId,
  getZoneByRegionId,
  getProgramTypes,
  getPrograms,
  getCategories,
  getCourses,
  getActivityDeliveries,
  getCatIIRequirements,
  getFoundedBy,
  getCertReason,
  getUser,
  getUserRole,
  isCertificateApprovalComplete
} from "../../../utils/helper";
import {TraineeService} from "../trainees.service";
import HrdNewTraineeEdit from "./hrd-new-trainee-edit.vue";
import {PrefixEnum} from "@/utils/enums";
import UploadExcelComponent from "@/components/Graduates/UploadExcel.vue";
import importErrorModal from "@/components/Graduates/importErrorModal.vue";
import {generateCertificate1, resolveCertificateEmail} from "../generate-certiificate";
import {settings} from "@/Settings";
import JSZip from "jszip";
import {TrainingCenterService} from "@/components/TrainingCenter/training_center.service";

const ExcelJS = require('exceljs');
const {saveAs} = require('file-saver');


extend("required", {
  ...required,
  message: "This field is required",
});

extend("phone_regex", {
  ...regex,
  message: "Use +251 then 9 or 7 and 8 digits (e.g. +2519xxxxxxx).",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});

extend("email", {
  ...email,
  message: "Facility email must be valid",
});

export default {
  props: {
    fromRoute: String,
  },
  components: {
    importErrorModal,
    UploadExcelComponent,
    ValidationObserver,
    ValidationProvider,
    HrdNewTraineeEdit,
  },
  data() {
    return {
      formValues: {
        firstName: "",
        middleName: "",
        lastName: "",
        healthProfessionId: null,
        woredaId: null,
        phoneNumber: "",
        licenseNumber: "",
        employeeId: null,
        facilityId: null,
        gender: "",
        kebele: null,
        facilityEmail: null,
        unemployed: false,
        national_id: "",
        prefixes: [],
      },
      defaultRegion: null,
      REGIONS: [],
      ZONES: [],
      WOREDAS: [],
      FACILITIES: [],
      defaultZone: null,
      PROFESSIONS: [],
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      tab: null,
      tabItems: ["Add New Trainee", "New Trainee History"],
      loading: false,
      newTraineeheaders: [
        {text: "Full Name", value: "fullName"},
        {text: "Gender", value: "gender"},
        {text: "Phone Number", value: "phoneNumber"},
        {text: "Employee Id", value: "employeeId"},
        {text: "License Number", value: "licenseNumber"},
        {text: "Profession", value: "healthProfession.name"},
        {text: "Location", value: "location"},
        {text: "Facility", value: "facility.name"},
        {text: "Verification", value: "verificationStatus"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      newTrainees: [],
      searchNewTrainee: "",
      searchNewTraineeDebounce: null,
      searchDebounce: null,
      newTrainee: null,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      editDialog: false,
      NEW_TRAINEE_FACILITIES: [],
      traineeListLoading: false,
      regionLoading: false,
      professionLoading: false,
      facilityLoading: false,
      woredaLoading: false,
      zoneLoading: false,
      searchable: true,
      clearable: true,
      prefixes: [],
      unemployed: false,

      region: [],
      profession: [],
      showForm: true,
      fileName: "",
      templateDownloadLoading: false,
      templateDownloadProgress: 0,
      templateDownloadMessage: "",
      templateDownloadedAt: null,
      importStep: 1,
      importCategoryType: "CAT2",
      COURSES: [],
      ACTIVITY_DELIVERIES: [],
      completionMenu: false,
      activityStartMenu: false,
      activityEndMenu: false,
      activityFormErrors: {},
      completion: {
        courseCompletionDate: "",
        certificateReason: null,
      },
      CERTIFICATE_REASONS: [],
      certReasonLoading: false,
      PROGRAM_TYPES: [],
      CPD_CATEGORIES: [],
      activityCatIIRequirements: [],
      catIILoading: false,
      CPD_PROVIDERS: [],
      cpdProviderLoading: false,
      FUNDED_BY: [],
      FACILITATED_BY_OPTIONS: [],
      COLLABORATOR_OPTIONS: [],
      importErrors: [],
      importErrorsDialog: false,
      traineeErrorList: [],
      traineeErrorDetails: [],
      activityErrors: [],
      csvHeaders: [],
      csvResults: [],
      importActivity: null,
      importedData: [],
      bulkImportLoading: false,
      bulkImportMessage: "",
      bulkImportErrors: [],
      bulkImportWarnings: [],
      bulkImportWarningsDialog: false,
      bulkImportedUpdates: [],
      bulkCertificateLoading: false,
      bulkCertificateErrors: [],
      bulkProgress: {
        total: 0,
        current: 0,
      },
      previewOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      traineeDefaults: {
        cat2Role: "",
        cat2MultiplierValue: null,
      },
    };
  },
  computed: {
    isCategory1Import() {
      return this.importCategoryType === "CAT1";
    },
    importCategories() {
      return this.CPD_CATEGORIES.filter((category) => (category.categoryType || "CAT2") === this.importCategoryType);
    },
    importCourseLevels() {
      const course = this.COURSES.find((item) => Number(item.id) === Number(this.importActivity?.courseId));
      return this.getImportCourseLevels(course);
    },
    importTraineeHeaders() {
      return this.isCategory1Import
          ? this.csvHeaders.filter((header) => !["cat2Role", "cat2MultiplierValue", "ceu"].includes(header.value))
          : this.csvHeaders;
    },
    isAddNewTraineeTab() {
      return this.tabItems[this.tab] === "Add New Trainee";
    },
    hasTraineeErrors() {
      return this.traineeErrorDetails.length > 0 || this.traineeErrorList.length > 0;
    },
    hasActivityErrors() {
      return this.activityErrors.length > 0;
    },
    isCompletionValid() {
      return this.isCategory1Import || (!!this.completion.courseCompletionDate && !!this.completion.certificateReason);
    },
    canMoveToTrainees() {
      return this.csvResults.length > 0 && this.importActivity !== null;
    },
    activityPreviewRows() {
      if (!this.importActivity) return [];
      const defaultRequirement = this.getCatIIRequirementByRole(this.traineeDefaults.cat2Role);
      const defaultCeu = this.calculateCat2Ceu(
          defaultRequirement,
          this.traineeDefaults.cat2MultiplierValue
      );
      return [
        {label: "CPD Activity Type", value: this.importActivity.programTypeName || "-"},
        {label: "CPD Activity", value: this.importActivity.categoryName || "-"},
        {label: "CPD Provider", value: this.importActivity.cpdProviderName || "-"},
        ...(this.isCategory1Import ? [
          {label: "Course", value: this.courseDisplayName(this.COURSES.find((course) => Number(course.id) === Number(this.importActivity.courseId))) || "-"},
          {label: "Course level", value: this.importCourseLevels.find((level) => Number(level.id) === Number(this.importActivity.courseLevelId))?.name || "-"},
          {label: "CEU", value: this.importCourseLevels.find((level) => Number(level.id) === Number(this.importActivity.courseLevelId))?.continualEducationUnit ?? "-"},
          {label: "Activity delivery", value: this.ACTIVITY_DELIVERIES.find((item) => Number(item.id) === Number(this.importActivity.activityDeliveryId))?.name || "-"},
        ] : [
        {label: "Course Title", value: this.importActivity.courseTitleCat2 || "-"},
        {label: "Default Cat II Role", value: defaultRequirement?.role || "-"},
        {label: "Default Multiplier", value: defaultRequirement?.multiplier || "-"},
        {label: "Default Multiplier Value", value: this.traineeDefaults.cat2MultiplierValue ?? "-"},
        {label: "CEU", value: defaultCeu ?? "-"},
        ]),
        {label: "Facilitated By", value: this.importActivity.facilitatedBy || "-"},
        {label: "Participants Number", value: this.importActivity.participantsNumber ?? "-"},
        {label: "Start Date", value: this.importActivity.startDate || "-"},
        {label: "End Date", value: this.importActivity.endDate || "-"},
        {label: "Funded By", value: this.importActivity.fundedByName || "-"},
        {label: "Total Cost", value: this.importActivity.totalCost ?? "-"},
        {label: "Color", value: this.importActivity.color || "-"},
        {label: "Expected Outcome", value: this.importActivity.expectedOutcome || "-"},
        {label: "Collaborator", value: this.importActivity.collaborator || "-"},
      ];
    },
    bulkProgressPercent() {
      if (!this.bulkProgress.total) return 0;
      return Math.round((this.bulkProgress.current / this.bulkProgress.total) * 100);
    },
    bulkImportedPendingApprovalCount() {
      return (this.bulkImportedUpdates || []).filter(
          (update) => !this.isImportedCertificateApproved(update)
      ).length;
    },
    areBulkImportedCertificatesApproved() {
      return this.bulkImportedUpdates.length > 0 &&
          this.bulkImportedPendingApprovalCount === 0;
    },
    professionNames() {
      return this.PROFESSIONS.map((item) => item.name);
    },
    regionNames() {
      return this.REGIONS.map((item) => item.name);
    },
    zoneNames() {
      return this.ZONES.map((item) => item.name);
    },
    woredaNames() {
      return this.WOREDAS.map((item) => item.name);
    },
    facilityNames() {
      return this.FACILITIES.map((item) => item.name);
    },
    catIIRoleOptions() {
      return (this.activityCatIIRequirements || [])
          .map((item) => this.toTrimmedString(item?.role))
          .filter((item) => item);
    },
    isSystemAdmin() {
      const roleName = (getUserRole() || "").toString().trim();
      return accessPolicy(getUser()) ? accessPolicy(getUser()).organization?.kind === "ministry" : roleName === "System admins";
    },
    userCpdProviderId() {
      const user = getUser();
      return user?.data?.cpdProviderId ?? null;
    },
    isCpdProviderLocked() {
      return !this.isSystemAdmin && !!this.userCpdProviderId;
    },
  },
  async created() {
    this.prefixes = await PrefixEnum;
    this.formValues.phoneNumber = normalizeEthiopianPhone(this.formValues.phoneNumber, {forcePrefix: true});
  },
  async beforeMount() {
    if (this.fromRoute === "Add") {
      this.tab = 0;
    } else if (this.fromRoute === "History") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
    this.fetchNewTrainees();
    this.regionLoading = true;
    this.professionLoading = true;
    this.facilityLoading = true;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
    const healthProfs = await getHealthProfessions();
    this.PROFESSIONS = healthProfs.rows.filter((data) => {
      return data.isActive == true;
    });
    this.professionLoading = false;
    const zoneRows = await getZoneByRegionId();
    this.ZONES = Array.isArray(zoneRows) ? zoneRows : [];
    const woredaRows = await getWoredaByZoneId();
    this.WOREDAS = Array.isArray(woredaRows) ? woredaRows : [];
    const facilityRows = await getFacilitiesByWoredaId();
    this.FACILITIES = Array.isArray(facilityRows) ? facilityRows : [];

    this.PROGRAM_TYPES = await getProgramTypes();
    const categories = await getCategories();
    this.CPD_CATEGORIES = categories;
    this.COURSES = (await getCourses()).filter((course) => course.isAccredited !== false);
    this.ACTIVITY_DELIVERIES = await getActivityDeliveries();
    const allPrograms = await getPrograms();
    const programRows = this.extractRows(allPrograms);
    this.FACILITATED_BY_OPTIONS = this.uniqueStringList(
        programRows.map((program) => program?.facilitatedBy)
    );
    this.COLLABORATOR_OPTIONS = this.uniqueStringList(
        programRows.map((program) => program?.collaborator)
    );
    this.FUNDED_BY = await getFoundedBy();

    this.cpdProviderLoading = true;
    try {
      const providerResp = await TrainingCenterService.getAllTrainingCenters();
      const rows =
          Array.isArray(providerResp?.rows) ? providerResp.rows :
              (Array.isArray(providerResp?.data?.rows) ? providerResp.data.rows : []);
      this.CPD_PROVIDERS = (Array.isArray(rows) ? rows : []).filter((row) => row?.isActive === true);
    } catch (error) {
      this.CPD_PROVIDERS = [];
    } finally {
      this.cpdProviderLoading = false;
    }
    this.certReasonLoading = true;
    const certReasons = await getCertReason();
    this.CERTIFICATE_REASONS = certReasons?.rows
        ? certReasons.rows.filter((data) => data.isActive === true)
        : [];
    this.certReasonLoading = false;

    this.regionOnChange();
    this.zoneOnChange();
    this.woredaOnChange();
  },
  watch: {
    options: {
      handler() {
        this.fetchNewTrainees();
      },
      deep: true,
    },
    search: function (val) {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchNewTrainees();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchNewTrainees();
      }, 400);
    },
    searchNewTrainee: function (val) {
      if (this.searchNewTraineeDebounce) {
        clearTimeout(this.searchNewTraineeDebounce);
        this.searchNewTraineeDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchNewTrainees();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.searchNewTraineeDebounce = setTimeout(() => {
        this.fetchNewTrainees();
      }, 400);
    },
  },
  methods: {
    toTrimmedString(value) {
      return value == null ? "" : String(value).trim();
    },
    toNumberValue(value) {
      if (value === null || value === undefined || value === "") return null;
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    uniqueStringList(values = []) {
      const seen = new Set();
      const output = [];
      values.forEach((value) => {
        const trimmed = this.toTrimmedString(value);
        if (!trimmed) return;
        const key = trimmed.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        output.push(trimmed);
      });
      return output;
    },
    extractRows(payload) {
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload?.rows)) return payload.rows;
      if (Array.isArray(payload?.data?.rows)) return payload.data.rows;
      if (Array.isArray(payload?.data)) return payload.data;
      return [];
    },
    isValueInOptions(value, options = []) {
      const val = this.toTrimmedString(value).toLowerCase();
      if (!val) return false;
      return options.some((item) => this.toTrimmedString(item).toLowerCase() === val);
    },
    getCatIIRequirementByRole(role) {
      const roleValue = this.toTrimmedString(role);
      if (!roleValue) return null;
      return (this.activityCatIIRequirements || []).find((req) => {
        const reqRole = this.toTrimmedString(req?.role).toLowerCase();
        return reqRole === roleValue.toLowerCase();
      }) || null;
    },
    getLockedCpdProvider() {
      if (!this.userCpdProviderId) {
        return null;
      }

      return this.CPD_PROVIDERS.find(
          (item) => Number(item?.id) === Number(this.userCpdProviderId)
      ) || null;
    },
    getTemplateRegionId() {
      const user = getUser();
      const userRegionId = Number(user?.data?.regionId);
      if (Number.isFinite(userRegionId) && userRegionId > 0) {
        return userRegionId;
      }

      const provider = this.getLockedCpdProvider();
      const providerRegionId = Number(
          provider?.region_id ??
          provider?.regionId ??
          provider?.region?.id
      );

      if (Number.isFinite(providerRegionId) && providerRegionId > 0) {
        return providerRegionId;
      }

      return null;
    },
    getTemplateScopedLookups() {
      const regionId = this.getTemplateRegionId();
      const regions = regionId
          ? this.REGIONS.filter((region) => Number(region?.id) === Number(regionId))
          : [...this.REGIONS];
      const zones = regionId
          ? this.ZONES.filter((zone) => Number(zone?.regionId) === Number(regionId))
          : [...this.ZONES];
      const zoneIds = new Set(zones.map((zone) => Number(zone?.id)));
      const woredas = regionId
          ? this.WOREDAS.filter((woreda) => zoneIds.has(Number(woreda?.zoneId)))
          : [...this.WOREDAS];
      const woredaIds = new Set(woredas.map((woreda) => Number(woreda?.id)));
      const facilities = regionId
          ? this.FACILITIES.filter((facility) => woredaIds.has(Number(facility?.woredaId)))
          : [...this.FACILITIES];

      let providers = regionId
          ? this.CPD_PROVIDERS.filter((provider) => {
            const providerRegionId = Number(
                provider?.region_id ??
                provider?.regionId ??
                provider?.region?.id
            );
            return providerRegionId === Number(regionId);
          })
          : [...this.CPD_PROVIDERS];

      const lockedProvider = this.getLockedCpdProvider();
      if (lockedProvider) {
        providers = providers.filter(
            (provider) => Number(provider?.id) === Number(lockedProvider.id)
        );
        if (!providers.length) {
          providers = [lockedProvider];
        }
      }

      return {
        regionId,
        regions,
        zones,
        woredas,
        facilities,
        providers,
      };
    },
    calculateCat2Ceu(requirement, multiplierValue) {
      const baseCeu = this.toNumberValue(requirement?.ceu);
      if (baseCeu === null) return null;
      if (!requirement?.multiplier) return baseCeu;
      const multiplier = this.toNumberValue(multiplierValue);
      if (multiplier === null) return null;
      return baseCeu * multiplier;
    },
    requiresCat2Multiplier(role) {
      const requirement = this.getCatIIRequirementByRole(role);
      return Boolean(requirement?.multiplier);
    },
    applyDefaultCat2Values({
      overwriteRole = false,
      overwriteMultiplier = false,
    } = {}) {
      if (!this.csvResults.length) return;
      const defaultRole = this.toTrimmedString(this.traineeDefaults.cat2Role);
      const defaultMultiplier = this.toNumberValue(this.traineeDefaults.cat2MultiplierValue);

      this.csvResults = this.csvResults.map((item) => {
        const nextItem = {...item};
        if (overwriteRole) {
          nextItem.cat2Role = defaultRole;
        }

        const effectiveRole = this.toTrimmedString(nextItem.cat2Role);
        if (!this.requiresCat2Multiplier(effectiveRole)) {
          nextItem.cat2MultiplierValue = null;
          return nextItem;
        }

        if (overwriteMultiplier) {
          nextItem.cat2MultiplierValue = defaultMultiplier;
        }

        return nextItem;
      });
      this.onTraineeEdit();
    },
    onDefaultCat2RoleChange() {
      if (!this.requiresCat2Multiplier(this.traineeDefaults.cat2Role)) {
        this.traineeDefaults.cat2MultiplierValue = null;
      }
      this.applyDefaultCat2Values({
        overwriteRole: true,
        overwriteMultiplier: true,
      });
    },
    onDefaultCat2MultiplierChange() {
      this.applyDefaultCat2Values({
        overwriteMultiplier: true,
      });
    },
    getRowZoneOptions(item) {
      const regionName = this.toTrimmedString(item?.region).toLowerCase();
      if (!regionName) return this.zoneNames;
      const region = this.REGIONS.find(
          (entry) => this.toTrimmedString(entry?.name).toLowerCase() === regionName
      );
      if (!region) return [];
      return this.uniqueStringList(this.ZONES
          .filter((zone) => Number(zone?.regionId) === Number(region.id))
          .map((zone) => zone.name));
    },
    getRowWoredaOptions(item) {
      const regionName = this.toTrimmedString(item?.region).toLowerCase();
      const zoneName = this.toTrimmedString(item?.zone).toLowerCase();
      if (!zoneName) return this.woredaNames;
      const region = regionName
          ? this.REGIONS.find((entry) => this.toTrimmedString(entry?.name).toLowerCase() === regionName)
          : null;
      const zones = this.ZONES.filter(
          (entry) =>
              this.toTrimmedString(entry?.name).toLowerCase() === zoneName &&
              (!region || Number(entry?.regionId) === Number(region.id))
      );
      if (!zones.length) return [];
      const zoneIds = new Set(zones.map((zone) => Number(zone.id)));
      return this.uniqueStringList(this.WOREDAS
          .filter((woreda) => zoneIds.has(Number(woreda?.zoneId)))
          .map((woreda) => woreda.name));
    },
    getRowFacilityOptions(item) {
      const regionName = this.toTrimmedString(item?.region).toLowerCase();
      const zoneName = this.toTrimmedString(item?.zone).toLowerCase();
      const woredaName = this.toTrimmedString(item?.woreda).toLowerCase();
      if (!woredaName) return this.facilityNames;
      const region = regionName
          ? this.REGIONS.find((entry) => this.toTrimmedString(entry?.name).toLowerCase() === regionName)
          : null;
      const zones = zoneName
          ? this.ZONES.filter(
              (entry) =>
                  this.toTrimmedString(entry?.name).toLowerCase() === zoneName &&
                  (!region || Number(entry?.regionId) === Number(region.id))
          )
          : [];
      const zoneIds = new Set(zones.map((zone) => Number(zone.id)));
      const woredas = this.WOREDAS.filter(
          (entry) =>
              this.toTrimmedString(entry?.name).toLowerCase() === woredaName &&
              (!zoneIds.size || zoneIds.has(Number(entry?.zoneId)))
      );
      if (!woredas.length) return [];
      const woredaIds = new Set(woredas.map((woreda) => Number(woreda.id)));
      return this.uniqueStringList(this.FACILITIES
          .filter((facility) => woredaIds.has(Number(facility?.woredaId)))
          .map((facility) => facility.name));
    },
    async loadActivityCatIIRequirements(categoryId) {
      if (this.isCategory1Import) {
        this.activityCatIIRequirements = [];
        return;
      }
      const parsedCategoryId = Number(categoryId);
      if (!parsedCategoryId) {
        this.activityCatIIRequirements = [];
        return;
      }
      this.catIILoading = true;
      const res = await getCatIIRequirements({cpdCategoryId: parsedCategoryId});
      const rows = this.extractRows(res);
      this.activityCatIIRequirements = Array.isArray(rows) ? rows : [];
      this.catIILoading = false;
    },
    async onActivityCategoryChange() {
      if (!this.importActivity) return;
      await this.loadActivityCatIIRequirements(this.importActivity.categoryId);
      const defaultRole = this.toTrimmedString(this.traineeDefaults.cat2Role);
      const isDefaultRoleStillValid = !defaultRole || this.catIIRoleOptions.some(
          (role) => this.toTrimmedString(role).toLowerCase() === defaultRole.toLowerCase()
      );
      if (!isDefaultRoleStillValid) {
        this.traineeDefaults.cat2Role = "";
        this.traineeDefaults.cat2MultiplierValue = null;
      }
      if (this.csvResults.length) {
        this.revalidateTrainees();
      }
      this.onActivityChange();
    },
    onPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {forcePrefix});
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    onBulkPhoneInput(item, value) {
      const rawValue = value == null ? "" : String(value);
      const trimmed = rawValue.trim();
      if (!trimmed) {
        item.phoneNumber = "";
      } else if (isValidEthiopianPhone(trimmed)) {
        item.phoneNumber = normalizeEthiopianPhone(trimmed, {forcePrefix: false});
      } else {
        item.phoneNumber = trimmed;
      }
      this.onTraineeEdit();
    },
    async regionOnChange(event = null) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = await getZoneByRegionId(event?.id);
      this.defaultZone = null;
      this.zoneLoading = false;
    },
    getFacilityDisplayText(facility) {
      const name = this.toTrimmedString(facility?.name);
      const code = facility?.id ?? null;
      if (name && code !== null && code !== undefined) {
        return `${name} (${code})`;
      }
      return name || (code !== null && code !== undefined ? String(code) : "-");
    },
    async zoneOnChange(event = null) {
      this.woredaLoading = true;
      this.FILTERED_WOREDAS = await getWoredaByZoneId(event?.id);
      this.defaultRegion = event?.regionId;
      this.formValues.woredaId = null;
      this.woredaLoading = false;
    },
    async woredaOnChange(event = null) {
      this.facilityLoading = true;
      this.formValues.woredaId = event?.id;
      this.NEW_TRAINEE_FACILITIES = await getFacilitiesByWoredaId(event?.id);
      this.defaultZone = this.FILTERED_ZONES?.find(x => x.id == event?.zoneId);
      this.defaultRegion = this.defaultZone?.regionId;
      this.formValues.facilityId = null;
      this.facilityLoading = false;
    },
    async facilityOnChange(event = null) {
      this.formValues.facilityId = event?.id;
      let woreda = this.FILTERED_WOREDAS?.find(x => x.id == event?.woredaId);
      this.formValues.woredaId = woreda?.id;
      this.defaultZone = this.FILTERED_ZONES?.find(x => x.id == woreda?.zoneId);
      this.defaultRegion = this.defaultZone?.regionId;
    },
    backToTrainee() {
      this.$router.push({
        path: "/traineeRegistration",
        name: "Trainee",
        params: {fromRoute: "Back"},
      });
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();

      let res = null;
      res = await TraineeService.registerTrainee(this.formValues);

      if (res.data.resultCode == 0) {
        this.$toast.error(res.data.message);
      }
      if (res.status === 200) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.$router.push({
              path: "/traineeRegistration",
              name: "Trainee",
              params: {fromRoute: "Add"},
            });
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      }
    },
    editNewTrainee(item) {
      if (item?.canEditTrainee === false) {
        this.$toast.error("You can only edit trainees that you registered.");
        return;
      }
      this.newTrainee = item;
      this.title = "Edit Trainee";
      this.editDialog = true;
    },
    verificationStatusLabel(status) {
      const value = String(status || "PENDING_VERIFICATION").toUpperCase();
      if (value === "VERIFIED") return "Verified";
      if (value === "REJECTED") return "Rejected";
      return "Pending Verification";
    },
    verificationStatusColor(status) {
      const value = String(status || "PENDING_VERIFICATION").toUpperCase();
      if (value === "VERIFIED") return "success";
      if (value === "REJECTED") return "error";
      return "warning";
    },
    canReviewTrainee(item) {
      return item?.canVerifyTrainee === true &&
          String(item?.verificationStatus || "PENDING_VERIFICATION").toUpperCase() ===
          "PENDING_VERIFICATION";
    },
    async reviewTrainee(item, action) {
      if (!this.canReviewTrainee(item)) return;
      let comment = null;
      if (action === "reject") {
        comment = window.prompt("Enter the reason for rejecting this trainee:");
        if (comment === null) return;
      }
      const response = await TraineeService.verifyNewTrainee(item.id, {action, comment});
      const body = response?.data || {};
      if ((response.status === 200 || response.status === 201) && body.status === 200) {
        this.$toast.success(body.message);
        await this.fetchNewTrainees();
        return;
      }
      this.$toast.error(body.message || "Unable to review trainee.");
    },
    async fetchNewTrainees() {
      this.traineeListLoading = true;
      const {page, itemsPerPage} = this.options;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      this.searchNewTrainee !== null &&
      (params += '&name=' + encodeURIComponent(this.searchNewTrainee));
      const res = await TraineeService.getTraineesList(params);
      if (res.status === 200) {
        this.newTrainees = res.data;
        this.traineeListLoading = false;
      }
      this.traineeListLoading = false;
    },
    closeDialog() {
      this.editDialog = false;
      this.fetchNewTrainees();
    },
    async updateTrainee(trainee) {
      let res = null;

      res = await TraineeService.updateNewTrainee(trainee.id, trainee);
      if (res.status === 201) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.fetchNewTrainees();
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      } else {
        this.$toast.error("Unable to update trainee, please try again");
      }
    },
    unemployedChanged() {
      this.unemployed = Boolean(this.formValues.unemployed);
      if (this.formValues.unemployed) {
        this.formValues.facilityId = null;
      }
    },
    onImportCategoryChange() {
      this.resetImportState();
      this.templateDownloadedAt = null;
    },
    courseDisplayName(course) {
      return course ? `${course.courseName} (${course.courseCode || course.id})` : "";
    },
    getImportCourseLevels(course) {
      if (!course) return [];
      if (course.courseLevels?.length) {
        return course.courseLevels.map((level) => ({
          id: level.courseLevelId,
          name: level.courseLevel?.name || `Level ${level.courseLevelId}`,
          continualEducationUnit: level.continualEducationUnit ?? course.continualEducationUnit,
        }));
      }
      return course.courseLevelId ? [{
        id: course.courseLevelId,
        name: course.courseLevel?.name || `Level ${course.courseLevelId}`,
        continualEducationUnit: course.continualEducationUnit,
      }] : [];
    },
    onImportCourseChange() {
      this.importActivity.courseLevelId = this.importCourseLevels.length === 1 ? this.importCourseLevels[0].id : null;
      this.onActivityChange();
    },
    newImport() {
      this.showForm = false;
      this.importStep = 1;
      this.resetImportState();
    },
    goBack() {
      this.showForm = true;
      this.importStep = 1;
      this.resetImportState();
    },
    async handleSuccess({fileName, sheets}) {
      this.resetImportState();
      this.fileName = fileName;
      if (!sheets) {
        this.$toast.error("Please upload the new multi-sheet template.");
        return;
      }

      const activitySheet = this.getSheetByName(sheets, "CPD Activity");
      const completionSheet = this.getSheetByName(sheets, "Completion");
      const traineeSheet = this.getSheetByName(sheets, "Trainees") || this.getFallbackTraineeSheet(sheets);
      if (!traineeSheet) {
        this.$toast.error("Unable to find trainee data in uploaded file.");
        return;
      }

      if (!activitySheet) {
        this.importActivity = this.createEmptyImportActivity();
        this.applyLockedCpdProvider(this.importActivity);
        this.$toast.info("CPD Activity sheet not found. Please complete CPD Activity in step 2.");
      } else if (activitySheet.results.length !== 1) {
        this.importActivity = this.createEmptyImportActivity();
        this.applyLockedCpdProvider(this.importActivity);
        this.$toast.info("CPD Activity sheet must have one row. Please complete CPD Activity in step 2.");
      } else {
        const {activity} = this.mapActivityRow(activitySheet.results[0]);
        this.applyLockedCpdProvider(activity);
        this.importActivity = activity;
      }
      await this.loadActivityCatIIRequirements(this.importActivity?.categoryId);
      this.validateActivityForm();

      if (!this.isCategory1Import && completionSheet?.results?.length === 1) {
        const completionRow = completionSheet.results[0];
        const completionDate = this.normalizeDate(
            this.getSheetValue(completionRow, [
              "courseCompletionDate",
              "Course Completion Date",
              "Completion Date",
            ])
        );
        const certificateReasonValue = this.toTrimmedString(
            this.getSheetValue(completionRow, [
              "certificateReason",
              "Certificate Reason",
            ])
        );
        const certificateReason = this.CERTIFICATE_REASONS.find(
            (item) =>
              String(item?.id) === certificateReasonValue ||
              this.toTrimmedString(item?.name).toLowerCase() ===
                certificateReasonValue.toLowerCase()
        );
        this.completion = {
          courseCompletionDate: completionDate,
          certificateReason: certificateReason?.id || null,
        };
      }

      const {mappedTrainees, previewRows, errors, errorRows, errorDetails} = this.mapTraineeRows(traineeSheet.results);
      this.importedData = mappedTrainees;
      this.csvResults = previewRows;
      this.traineeErrorList = errors;
      this.traineeErrorDetails = errorDetails;
      this.importErrors = errorRows;
      this.importErrorsDialog = errors.length > 0;

      this.csvHeaders = [
        {text: "Prefix", value: "prefix"},
        {text: "First Name", value: "firstName"},
        {text: "Father Name", value: "fatherName"},
        {text: "Grandfather Name", value: "grandfatherName"},
        {text: "Gender", value: "gender"},
        {text: "Profession", value: "profession"},
        {text: "Region", value: "region"},
        {text: "Zone", value: "zone"},
        {text: "Woreda", value: "woreda"},
        {text: "Facility", value: "facility"},
        {text: "Cat II Role", value: "cat2Role"},
        {text: "Multiplier Value", value: "cat2MultiplierValue"},
        {text: "CEU", value: "ceu"},
        {text: "Kebele", value: "kebele"},
        {text: "Unemployed", value: "unemployed"},
        {text: "Email Address", value: "emailAddress"},
        {text: "Phone Number", value: "phoneNumber"},
        {text: "Employee Id", value: "employeeId"},
        {text: "License Number", value: "licenseNumber"},
        {text: "National Id", value: "nationalId"},
      ];

      this.importStep = 2;
    },
    resetImportState() {
      this.fileName = "";
      this.importStep = 1;
      this.importErrors = [];
      this.importErrorsDialog = false;
      this.traineeErrorList = [];
      this.traineeErrorDetails = [];
      this.activityErrors = [];
      this.activityFormErrors = {};
      this.csvHeaders = [];
      this.csvResults = [];
      this.importedData = [];
      this.importActivity = null;
      this.activityCatIIRequirements = [];
      this.traineeDefaults = {
        cat2Role: "",
        cat2MultiplierValue: null,
      };
      this.completion = {
        courseCompletionDate: "",
        certificateReason: null,
      };
      this.bulkImportErrors = [];
      this.bulkImportWarnings = [];
      this.bulkImportWarningsDialog = false;
      this.bulkImportedUpdates = [];
      this.bulkCertificateLoading = false;
      this.bulkCertificateErrors = [];
      this.bulkImportMessage = "";
      this.bulkProgress = {total: 0, current: 0};
      this.previewOptions = {
        page: 1,
        itemsPerPage: 10,
      };
    },
    getSheetByName(sheets, name) {
      if (sheets[name]) return sheets[name];
      const lowerName = name.toLowerCase();
      const matchedKey = Object.keys(sheets).find((key) => key.toLowerCase() === lowerName);
      return matchedKey ? sheets[matchedKey] : null;
    },
    normalizeSheetKey(key) {
      return this.toTrimmedString(key).toLowerCase().replace(/[^a-z0-9]/g, "");
    },
    hasSheetValue(value) {
      if (value === null || value === undefined) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    },
    normalizeDate(value) {
      if (!value) return "";
      if (value instanceof Date) {
        return value.toISOString().slice(0, 10);
      }
      if (typeof value === "number") {
        const date = new Date(Math.round((value - 25569) * 86400 * 1000));
        return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
      }
      const rawValue = value.toString().trim();
      const isoMatch = rawValue.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
      if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }

      const localDateMatch = rawValue.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{2,4})$/);
      if (localDateMatch) {
        let [, first, second, year] = localDateMatch;
        if (year.length === 2) {
          year = `${Number(year) >= 70 ? "19" : "20"}${year}`;
        }

        let day = first;
        let month = second;
        if (Number(second) > 12 && Number(first) <= 12) {
          day = second;
          month = first;
        }

        const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
        if (
            parsedDate.getFullYear() === Number(year) &&
            parsedDate.getMonth() === Number(month) - 1 &&
            parsedDate.getDate() === Number(day)
        ) {
          return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
      }

      const parsedDate = new Date(rawValue);
      return Number.isNaN(parsedDate.getTime()) ? rawValue.slice(0, 10) : parsedDate.toISOString().slice(0, 10);
    },
    getSheetValue(row, keys = []) {
      if (!row || typeof row !== "object") return null;
      const normalizedRow = {};
      Object.keys(row).forEach((key) => {
        const normalizedKey = this.normalizeSheetKey(key);
        if (!normalizedKey) return;
        if (!Object.prototype.hasOwnProperty.call(normalizedRow, normalizedKey)) {
          normalizedRow[normalizedKey] = row[key];
        }
      });
      for (const key of keys) {
        if (!key) continue;
        if (Object.prototype.hasOwnProperty.call(row, key) && this.hasSheetValue(row[key])) {
          return row[key];
        }
        const normalizedKey = this.normalizeSheetKey(key);
        if (normalizedKey && Object.prototype.hasOwnProperty.call(normalizedRow, normalizedKey) && this.hasSheetValue(normalizedRow[normalizedKey])) {
          return normalizedRow[normalizedKey];
        }
      }
      return null;
    },
    createEmptyImportActivity() {
      return {
        programTypeId: null,
        programTypeName: "",
        categoryId: null,
        categoryName: "",
        cpdProviderId: null,
        cpdProviderName: "",
        courseTitleCat2: "",
        courseId: null,
        courseLevelId: null,
        activityDeliveryId: null,
        facilitatedBy: "",
        participantsNumber: null,
        startDate: "",
        endDate: "",
        fundedById: null,
        fundedByName: "",
        totalCost: null,
        color: "",
        expectedOutcome: "",
        collaborator: "",
      };
    },
    applyLockedCpdProvider(activity) {
      if (!activity || !this.isCpdProviderLocked || !this.userCpdProviderId) return;
      const provider = this.CPD_PROVIDERS.find((item) => Number(item?.id) === Number(this.userCpdProviderId)) || null;
      activity.cpdProviderId = this.userCpdProviderId;
      activity.cpdProviderName = provider ? provider.trainingCenterName : activity.cpdProviderName;
    },
    getFallbackTraineeSheet(sheets) {
      const entries = Object.entries(sheets || {});
      if (!entries.length) return null;

      const sheetScores = entries
          .filter(([, sheet]) => Array.isArray(sheet?.results))
          .map(([name, sheet]) => {
            const headers = Array.isArray(sheet?.header) ? sheet.header : [];
            const headerSet = new Set(headers.map((header) => this.normalizeSheetKey(header)));
            const scoreKeys = [
              "firstname",
              "fathername",
              "grandfathername",
              "gender",
              "profession",
              "emailaddress",
              "phonenumber",
              "catiirole",
            ];
            const score = scoreKeys.reduce((acc, key) => acc + (headerSet.has(key) ? 1 : 0), 0);
            const rowCount = Array.isArray(sheet?.results) ? sheet.results.length : 0;
            return {name, sheet, score, rowCount};
          })
          .filter((entry) => entry.name.toLowerCase() !== "cpd activity" && entry.name.toLowerCase() !== "lookups");

      if (!sheetScores.length) return null;
      sheetScores.sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        return b.rowCount - a.rowCount;
      });
      return sheetScores[0].sheet || null;
    },
    normalizeTraineeRow(person = {}) {
      return {
        prefix: this.toTrimmedString(this.getSheetValue(person, [
          "prefix",
          "Prefix",
          "title",
          "Title",
          "traineePrefix",
          "Trainee Prefix",
        ])),
        firstName: this.toTrimmedString(this.getSheetValue(person, [
          "firstName",
          "First Name",
          "first name",
          "Given Name",
        ])),
        fatherName: this.toTrimmedString(this.getSheetValue(person, [
          "fatherName",
          "Father Name",
          "father name",
          "Middle Name",
          "middle name",
        ])),
        grandfatherName: this.toTrimmedString(this.getSheetValue(person, [
          "grandfatherName",
          "Grandfather Name",
          "grandfather name",
          "Last Name",
          "last name",
          "Surname",
          "Family Name",
        ])),
        gender: this.toTrimmedString(this.getSheetValue(person, [
          "gender",
          "Gender",
          "sex",
          "Sex",
        ])),
        profession: this.toTrimmedString(this.getSheetValue(person, [
          "profession",
          "Profession",
          "Health Profession",
          "Health Professional",
          "Professional Category",
        ])),
        region: this.toTrimmedString(this.getSheetValue(person, [
          "region",
          "Region",
        ])),
        zone: this.toTrimmedString(this.getSheetValue(person, [
          "zone",
          "Zone",
        ])),
        woreda: this.toTrimmedString(this.getSheetValue(person, [
          "woreda",
          "Woreda",
        ])),
        facility: this.toTrimmedString(this.getSheetValue(person, [
          "facility",
          "Facility",
          "Facility Name",
          "Health Facility",
        ])),
        cat2Role: this.toTrimmedString(this.getSheetValue(person, [
          "cat2Role",
          "Cat II Role",
          "Cat2 Role",
          "Cat 2 Role",
          "Role",
        ])),
        cat2MultiplierValue: this.getSheetValue(person, [
          "cat2MultiplierValue",
          "Cat II Multiplier Value",
          "Cat2 Multiplier Value",
          "Multiplier Value",
          "Multiplier",
        ]),
        kebele: this.toTrimmedString(this.getSheetValue(person, [
          "kebele",
          "Kebele",
        ])),
        unemployed: this.toTrimmedString(this.getSheetValue(person, [
          "unemployed",
          "Unemployed",
        ])),
        emailAddress: this.toTrimmedString(this.getSheetValue(person, [
          "emailAddress",
          "Email Address",
          "email",
          "Email",
          "Facility Email",
        ])),
        phoneNumber: this.toTrimmedString(this.getSheetValue(person, [
          "phoneNumber",
          "Phone Number",
          "phone",
          "Phone",
          "Mobile Number",
          "Mobile",
          "Cell Phone",
        ])),
        employeeId: this.toTrimmedString(this.getSheetValue(person, [
          "employeeId",
          "Employee Id",
          "Employee ID",
          "Employee Number",
        ])),
        licenseNumber: this.toTrimmedString(this.getSheetValue(person, [
          "licenseNumber",
          "License Number",
          "Professional License Number",
          "License No",
          "License #",
        ])),
        nationalId: this.toTrimmedString(this.getSheetValue(person, [
          "nationalId",
          "National Id",
          "National ID",
          "ID Number",
        ])),
      };
    },
    mapActivityRow(row) {
      const errors = [];
      const programTypeName = this.toTrimmedString(
          this.getSheetValue(row, ["programType", "Program Type", "CPD Activity Type"])
      );
      const categoryName = this.toTrimmedString(
          this.getSheetValue(row, ["category", "Category", "CPD Activity (Category 2)", "CPD Activity (Category I)", "CPD Activity"])
      );
      const cpdProviderName = this.toTrimmedString(
          this.getSheetValue(row, ["cpdProvider", "CPD Provider", "cpdProviderName", "provider"])
      );
      const fundedByName = this.toTrimmedString(
          this.getSheetValue(row, ["fundedBy", "Funded By", "Funded By:"])
      );
      const programType = this.PROGRAM_TYPES.find((item) => item.name === programTypeName);
      const category = this.importCategories.find((item) => item.name === categoryName);
      const cpdProvider = this.CPD_PROVIDERS.find(
          (item) => this.toTrimmedString(item?.trainingCenterName).toLowerCase() === cpdProviderName.toLowerCase()
      );
      const fundedBy = this.FUNDED_BY.find((item) => item.name === fundedByName);
      const activity = {
        programTypeId: programType ? programType.id : null,
        programTypeName: programType ? programType.name : programTypeName,
        categoryId: category ? category.id : null,
        categoryName: category ? category.name : categoryName,
        cpdProviderId: cpdProvider ? cpdProvider.id : null,
        cpdProviderName: cpdProvider ? cpdProvider.trainingCenterName : cpdProviderName,
        courseTitleCat2: this.toTrimmedString(
            this.getSheetValue(row, ["courseTitleCat2", "courseTitle", "Course Title", "Course Title (Cat2)"])
        ),
        facilitatedBy: this.toTrimmedString(
            this.getSheetValue(row, [
              "facilitatedBy",
              "Facilitated By",
              "Facilitated by",
              "Hosting Institution",
              "hostingInstitution",
            ])
        ),
        participantsNumber: this.toNumberValue(
            this.getSheetValue(row, ["participantsNumber", "Participants Number", "Number of Participants"])
        ),
        startDate: this.normalizeDate(this.getSheetValue(row, ["startDate", "Start Date"])),
        endDate: this.normalizeDate(this.getSheetValue(row, ["endDate", "End Date"])),
        fundedById: fundedBy ? fundedBy.id : null,
        fundedByName: fundedBy ? fundedBy.name : fundedByName,
        totalCost: this.toNumberValue(this.getSheetValue(row, ["totalCost", "Total Cost"])),
        color: this.toTrimmedString(this.getSheetValue(row, ["color", "Color"])),
        expectedOutcome: this.toTrimmedString(this.getSheetValue(row, ["expectedOutcome", "Expected Outcome"])) || null,
        collaborator: this.toTrimmedString(this.getSheetValue(row, ["collaborator", "Collaborator"])) || null,
      };

      if (this.isCategory1Import) {
        const courseValue = this.toTrimmedString(this.getSheetValue(row, ["courseId", "course", "Course", "courseTitle", "Course Title"]));
        const matches = this.COURSES.filter((course) =>
            [String(course.id), course.courseName, this.courseDisplayName(course)].some((value) =>
                this.toTrimmedString(value).toLowerCase() === courseValue.toLowerCase()));
        const course = matches.length === 1 ? matches[0] : null;
        const levelValue = this.toTrimmedString(this.getSheetValue(row, ["courseLevelId", "courseLevel", "Course Level"]));
        const level = this.getImportCourseLevels(course).find((item) => String(item.id) === levelValue || item.name.toLowerCase() === levelValue.toLowerCase());
        const deliveryValue = this.toTrimmedString(this.getSheetValue(row, ["activityDeliveryId", "activityDelivery", "Activity Delivery"]));
        const delivery = this.ACTIVITY_DELIVERIES.find((item) => String(item.id) === deliveryValue || item.name.toLowerCase() === deliveryValue.toLowerCase());
        activity.courseId = course?.id || null;
        activity.courseLevelId = level?.id || null;
        activity.activityDeliveryId = delivery?.id || null;
      }

      // If the logged-in user is a CPD provider user, lock to their provider id.
      this.applyLockedCpdProvider(activity);

      const requiredFields = [
        {key: "programTypeId", label: "programType"},
        {key: "categoryId", label: "category"},
        ...(this.isCategory1Import ? [
          {key: "courseId", label: "Category I course"},
          {key: "courseLevelId", label: "course level"},
          {key: "activityDeliveryId", label: "activity delivery"},
        ] : [{key: "courseTitleCat2", label: "courseTitle"}]),
        {key: "facilitatedBy", label: "facilitatedBy"},
        {key: "participantsNumber", label: "participantsNumber"},
        {key: "startDate", label: "startDate"},
        {key: "endDate", label: "endDate"},
        {key: "fundedById", label: "fundedBy"},
        {key: "totalCost", label: "totalCost"},
        {key: "color", label: "color"},
      ];

      requiredFields.forEach((field) => {
        if (!activity[field.key] && activity[field.key] !== 0) {
          errors.push(`Please fill ${field.label} in CPD Activity sheet.`);
        }
      });

      if (!this.userCpdProviderId && !activity.cpdProviderId) {
        errors.push("Please fill CPD Provider in CPD Activity sheet (or select it in step 2).");
      }

      if (this.COLLABORATOR_OPTIONS.length &&
          activity.collaborator &&
          !this.isValueInOptions(activity.collaborator, this.COLLABORATOR_OPTIONS)) {
        errors.push("Please fill collaborator in CPD Activity sheet through dropdown only.");
      }
      if (activity.participantsNumber != null && activity.participantsNumber < 1) {
        errors.push("Participants number must be at least 1.");
      }
      if (activity.totalCost != null && activity.totalCost < 0) {
        errors.push("Total cost must be zero or greater.");
      }
      if (activity.startDate && activity.endDate && activity.startDate > activity.endDate) {
        errors.push("Start date cannot be after end date.");
      }

      return {activity, errors};
    },
    validateActivityForm() {
      const errors = [];
      const fieldErrors = {};
      const activity = this.importActivity || {};

      const requiredFields = [
        {key: "programTypeId", label: "CPD activity type"},
        {key: "categoryId", label: "CPD activity"},
        ...(!this.userCpdProviderId ? [{key: "cpdProviderId", label: "CPD provider"}] : []),
        ...(this.isCategory1Import ? [
          {key: "courseId", label: "Category I course"},
          {key: "courseLevelId", label: "course level"},
          {key: "activityDeliveryId", label: "activity delivery"},
        ] : [{key: "courseTitleCat2", label: "course title"}]),
        {key: "facilitatedBy", label: "facilitated by"},
        {key: "participantsNumber", label: "participants number"},
        {key: "startDate", label: "start date"},
        {key: "endDate", label: "end date"},
        {key: "fundedById", label: "funded by"},
        {key: "totalCost", label: "total cost"},
        {key: "color", label: "color"},
      ];

      requiredFields.forEach((field) => {
        if (!activity[field.key] && activity[field.key] !== 0) {
          const message = `Please fill ${field.label}.`;
          errors.push(message);
          fieldErrors[field.key] = [message];
        }
      });

      if (!this.userCpdProviderId && activity.cpdProviderName && !activity.cpdProviderId) {
        const message = "Please choose CPD provider from dropdown values.";
        errors.push(message);
        fieldErrors.cpdProviderId = [message];
      }

      if (this.COLLABORATOR_OPTIONS.length &&
          activity.collaborator &&
          !this.isValueInOptions(activity.collaborator, this.COLLABORATOR_OPTIONS)) {
        const message = "Please choose collaborator from dropdown values.";
        errors.push(message);
        fieldErrors.collaborator = [message];
      }
      if (activity.participantsNumber != null && Number(activity.participantsNumber) < 1) {
        const message = "Participants number must be at least 1.";
        errors.push(message);
        fieldErrors.participantsNumber = [message];
      }
      if (activity.totalCost != null && Number(activity.totalCost) < 0) {
        const message = "Total cost must be zero or greater.";
        errors.push(message);
        fieldErrors.totalCost = [message];
      }
      if (activity.startDate && activity.endDate && activity.startDate > activity.endDate) {
        const message = "Start date cannot be after end date.";
        errors.push(message);
        fieldErrors.startDate = [message];
        fieldErrors.endDate = [message];
      }

      if (this.isCategory1Import && activity.courseLevelId && !this.importCourseLevels.some((level) => Number(level.id) === Number(activity.courseLevelId))) {
        const message = "Please choose a level configured for the selected course.";
        errors.push(message);
        fieldErrors.courseLevelId = [message];
      }
      this.activityErrors = errors;
      this.activityFormErrors = fieldErrors;
    },
    onActivityChange() {
      if (this.importActivity) {
        const programType = this.PROGRAM_TYPES.find((item) => item.id === this.importActivity.programTypeId);
        const category = this.importCategories.find((item) => item.id === this.importActivity.categoryId);
        const fundedBy = this.FUNDED_BY.find((item) => item.id === this.importActivity.fundedById);
        const provider = this.CPD_PROVIDERS.find((item) => Number(item?.id) === Number(this.importActivity.cpdProviderId));
        this.importActivity.programTypeName = programType ? programType.name : this.importActivity.programTypeName;
        this.importActivity.categoryName = category ? category.name : this.importActivity.categoryName;
        this.importActivity.fundedByName = fundedBy ? fundedBy.name : this.importActivity.fundedByName;
        this.importActivity.cpdProviderName = provider ? provider.trainingCenterName : this.importActivity.cpdProviderName;
      }
      this.validateActivityForm();
    },
    mapTraineeRows(rows) {
      const errors = [];
      const errorDetails = [];
      const errorRows = {};
      const requiredFields = [
        "firstName",
        "fatherName",
        "grandfatherName",
        "gender",
        "phoneNumber",
        "profession",
        "region",
        ...(!this.isCategory1Import ? ["cat2Role"] : []),
        "unemployed",
      ];
      const toTrimmedString = (value) => (value == null ? "" : String(value).trim());
      const isLikelyEmail = (value) => /\S+@\S+/.test(value);
      const isValidName = (value) => /^[A-Za-z][A-Za-z ]*$/.test(value);
      const allowedGenders = ["male", "female"];
      const allowedUnemployed = ["yes", "no"];
      const allowedPrefixes = Array.isArray(this.prefixes)
          ? this.prefixes
              .map((prefix) => toTrimmedString(prefix?.name).toLowerCase())
              .filter((name) => name)
          : [];

      const regionLookup = this.REGIONS.reduce((acc, region) => {
        const key = toTrimmedString(region?.name).toLowerCase();
        if (key) acc[key] = region;
        return acc;
      }, {});
      const zoneLookup = this.ZONES.reduce((acc, zone) => {
        const key = toTrimmedString(zone?.name).toLowerCase();
        if (key) {
          acc[key] = acc[key] || [];
          acc[key].push(zone);
        }
        return acc;
      }, {});
      const woredaLookup = this.WOREDAS.reduce((acc, woreda) => {
        const key = toTrimmedString(woreda?.name).toLowerCase();
        if (key) {
          acc[key] = acc[key] || [];
          acc[key].push(woreda);
        }
        return acc;
      }, {});
      const facilityLookup = this.FACILITIES.reduce((acc, facility) => {
        const keys = [
          toTrimmedString(facility?.name).toLowerCase(),
          this.getFacilityDisplayText(facility).toLowerCase(),
          facility?.id !== null && facility?.id !== undefined ? String(facility.id).toLowerCase() : "",
        ].filter((key, index, list) => key && list.indexOf(key) === index);
        keys.forEach((key) => {
          acc[key] = acc[key] || [];
          acc[key].push(facility);
        });
        return acc;
      }, {});
      const professionLookup = this.PROFESSIONS.reduce((acc, prof) => {
        const key = toTrimmedString(prof?.name).toLowerCase();
        if (key) acc[key] = prof.id;
        return acc;
      }, {});
      const zonesById = this.ZONES.reduce((acc, zone) => {
        acc[Number(zone?.id)] = zone;
        return acc;
      }, {});
      const woredasById = this.WOREDAS.reduce((acc, woreda) => {
        acc[Number(woreda?.id)] = woreda;
        return acc;
      }, {});

      const previewRows = [];
      const mappedTrainees = rows.map((person, index) => {
        const rowNumber = index + 1;
        const normalizedPerson = this.normalizeTraineeRow(person);
        requiredFields.forEach((field) => {
          if (!toTrimmedString(normalizedPerson[field])) {
            const message = `Please fill in ${field} column`;
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field});
          }
        });
        [
          ["firstName", "First name"],
          ["fatherName", "Father name"],
          ["grandfatherName", "Grandfather name"],
        ].forEach(([field, label]) => {
          const value = toTrimmedString(normalizedPerson[field]);
          if (value && !isValidName(value)) {
            const message = `${label} must contain letters and spaces only`;
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field});
          }
        });

        const rawPhone = toTrimmedString(normalizedPerson.phoneNumber);
        const phoneIsValid = rawPhone ? isValidEthiopianPhone(rawPhone) : false;
        const normalizedPhone = rawPhone
            ? normalizeEthiopianPhone(rawPhone, {forcePrefix: false})
            : "";
        const phoneDisplayValue = rawPhone ? (phoneIsValid ? normalizedPhone : rawPhone) : "";
        if (rawPhone && !phoneIsValid) {
          const message = "Phone number must be +251 followed by 9 or 7 and 8 digits";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "phoneNumber"});
        }

        const genderRaw = toTrimmedString(normalizedPerson.gender);
        const genderValue = genderRaw
            ? `${genderRaw.charAt(0).toUpperCase()}${genderRaw.slice(1).toLowerCase()}`
            : "";
        if (genderRaw && !allowedGenders.includes(genderRaw.toLowerCase())) {
          const message = "Gender must be Male or Female";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "gender"});
        }

        const emailValue = toTrimmedString(normalizedPerson.emailAddress);
        if (emailValue && !isLikelyEmail(emailValue)) {
          const message = "Enter a valid email address";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "emailAddress"});
        }

        const prefixValue = toTrimmedString(normalizedPerson.prefix);
        if (prefixValue && allowedPrefixes.length && !allowedPrefixes.includes(prefixValue.toLowerCase())) {
          const message = "Prefix must be selected from the provided list";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "prefix"});
        }

        const unemployedValue = toTrimmedString(normalizedPerson.unemployed);
        if (unemployedValue && !allowedUnemployed.includes(unemployedValue.toLowerCase())) {
          const message = "Unemployed must be Yes or No";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "unemployed"});
        }
        const isUnemployed = unemployedValue.toLowerCase() === "yes";

        const regionName = toTrimmedString(normalizedPerson.region);
        const zoneName = toTrimmedString(normalizedPerson.zone);
        const woredaName = toTrimmedString(normalizedPerson.woreda);
        const facilityName = toTrimmedString(normalizedPerson.facility);
        const defaultCat2Role = this.toTrimmedString(this.traineeDefaults.cat2Role);
        const cat2Role = toTrimmedString(normalizedPerson.cat2Role) || defaultCat2Role;
        const cat2MultiplierValue = this.toNumberValue(
            normalizedPerson.cat2MultiplierValue !== null &&
            normalizedPerson.cat2MultiplierValue !== undefined &&
            normalizedPerson.cat2MultiplierValue !== ""
                ? normalizedPerson.cat2MultiplierValue
                : this.traineeDefaults.cat2MultiplierValue
        );
        const professionName = toTrimmedString(normalizedPerson.profession);
        const regionObj = regionLookup[regionName.toLowerCase()];
        if (!regionObj) {
          const message = "Please fill the region column through select only";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "region"});
        }
        const zoneMatches = zoneName ? (zoneLookup[zoneName.toLowerCase()] || []) : [];
        let zoneObj = null;
        if (zoneName && !zoneMatches.length) {
          const message = "Please fill the zone column through select only";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "zone"});
        } else if (zoneName) {
          const filteredZones = regionObj
              ? zoneMatches.filter((zone) => Number(zone?.regionId) === Number(regionObj.id))
              : zoneMatches;
          if (filteredZones.length === 1) {
            zoneObj = filteredZones[0];
          } else if (!filteredZones.length && regionObj) {
            const message = "Zone must belong to selected region";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "zone"});
          } else if (filteredZones.length > 1) {
            const message = regionObj
                ? "Zone name is duplicated in selected region; please pick a unique value from dropdown"
                : "Zone name is duplicated; select region first, then choose zone from dropdown";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "zone"});
          }
        }

        const woredaMatches = woredaName ? (woredaLookup[woredaName.toLowerCase()] || []) : [];
        let woredaObj = null;
        if (woredaName && !woredaMatches.length) {
          const message = "Please fill the woreda column through select only";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "woreda"});
        } else if (woredaName) {
          const filteredWoredas = zoneObj
              ? woredaMatches.filter((woreda) => Number(woreda?.zoneId) === Number(zoneObj.id))
              : woredaMatches;
          if (filteredWoredas.length === 1) {
            woredaObj = filteredWoredas[0];
          } else if (!filteredWoredas.length && zoneObj) {
            const message = "Woreda must belong to selected zone";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "woreda"});
          } else if (filteredWoredas.length > 1) {
            const message = zoneObj
                ? "Woreda name is duplicated in selected zone; please pick a unique value from dropdown"
                : "Woreda name is duplicated; select zone first, then choose woreda from dropdown";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "woreda"});
          }
        }

        const facilityMatches = facilityName ? (facilityLookup[facilityName.toLowerCase()] || []) : [];
        let facilityObj = null;
        if (facilityName && !facilityMatches.length) {
          const message = "Please fill the facility column through select only";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "facility"});
        } else if (facilityName) {
          const filteredFacilities = woredaObj
              ? facilityMatches.filter((facility) => Number(facility?.woredaId) === Number(woredaObj.id))
              : facilityMatches;
          if (filteredFacilities.length === 1) {
            facilityObj = filteredFacilities[0];
          } else if (!filteredFacilities.length && woredaObj) {
            const message = "Facility must belong to selected woreda";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "facility"});
          } else if (filteredFacilities.length > 1) {
            const message = woredaObj
                ? "Facility name is duplicated in selected woreda; please pick a unique value from dropdown"
                : "Facility name is duplicated; select woreda first, then choose facility from dropdown";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "facility"});
          }
        }

        if (regionObj && zoneObj && Number(zoneObj.regionId) !== Number(regionObj.id)) {
          const message = "Zone must belong to selected region";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "zone"});
        }
        if (zoneObj && woredaObj && Number(woredaObj.zoneId) !== Number(zoneObj.id)) {
          const message = "Woreda must belong to selected zone";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "woreda"});
        }
        if (woredaObj && facilityObj && Number(facilityObj.woredaId) !== Number(woredaObj.id)) {
          const message = "Facility must belong to selected woreda";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "facility"});
        }
        if (!woredaObj && facilityObj) {
          const message = "Select woreda for the selected facility";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "woreda"});
        }
        if (
          unemployedValue &&
          allowedUnemployed.includes(unemployedValue.toLowerCase()) &&
          !isUnemployed &&
          !facilityObj
        ) {
          const message = "Facility is required when Unemployed is No";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "facility"});
        }

        const roleRequirement = this.isCategory1Import ? null : this.getCatIIRequirementByRole(cat2Role);
        let rowCeu = null;
        if (!this.isCategory1Import) {
          if (!roleRequirement) {
            const message = "Please select Cat II role from dropdown";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "cat2Role"});
          }
          if (roleRequirement?.multiplier && cat2MultiplierValue === null) {
            const message = `${roleRequirement.multiplier} is required`;
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "cat2MultiplierValue"});
          }
          rowCeu = this.calculateCat2Ceu(roleRequirement, cat2MultiplierValue);
          if (rowCeu === null) {
            const message = "Unable to calculate CEU for selected role";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "ceu"});
          } else if (Number(rowCeu) < 0 || Number(rowCeu) > 15) {
            const message = "CEU must be between 0 and 15";
            errors.push({message, row: rowNumber});
            errorDetails.push({message, row: rowNumber, field: "ceu"});
          }

        }

        const resolvedRegionId = regionObj
            ? regionObj.id
            : (
                zoneObj
                    ? zoneObj.regionId
                    : (
                        woredaObj
                            ? (zonesById[Number(woredaObj.zoneId)]?.regionId || null)
                            : (
                                facilityObj
                                    ? (
                                        zonesById[Number(
                                            woredasById[Number(facilityObj.woredaId)]?.zoneId
                                        )]?.regionId || null
                                    )
                                    : null
                            )
                    )
            );
        const resolvedWoredaId = woredaObj
            ? woredaObj.id
            : (facilityObj ? facilityObj.woredaId : null);

        const professionId = professionLookup[professionName.toLowerCase()];
        if (!professionId) {
          const message = "Please fill the profession column through select only";
          errors.push({message, row: rowNumber});
          errorDetails.push({message, row: rowNumber, field: "profession"});
        }

        previewRows.push({
          prefix: prefixValue,
          firstName: toTrimmedString(normalizedPerson.firstName),
          fatherName: toTrimmedString(normalizedPerson.fatherName),
          grandfatherName: toTrimmedString(normalizedPerson.grandfatherName),
          gender: genderValue,
          profession: professionName,
          region: regionName,
          zone: zoneName,
          woreda: woredaName,
          facility: facilityName,
          cat2Role,
          cat2MultiplierValue,
          ceu: rowCeu,
          kebele: toTrimmedString(normalizedPerson.kebele),
          unemployed: unemployedValue,
          emailAddress: emailValue,
          phoneNumber: phoneDisplayValue,
          employeeId: toTrimmedString(normalizedPerson.employeeId),
          licenseNumber: toTrimmedString(normalizedPerson.licenseNumber),
          nationalId: toTrimmedString(normalizedPerson.nationalId),
          __rowIndex: index,
        });

        return {
          firstName: toTrimmedString(normalizedPerson.firstName),
          middleName: toTrimmedString(normalizedPerson.fatherName),
          lastName: toTrimmedString(normalizedPerson.grandfatherName),
          gender: genderValue,
          phoneNumber: normalizedPhone,
          facilityEmail: emailValue,
          national_id: toTrimmedString(normalizedPerson.nationalId),
          kebele: toTrimmedString(normalizedPerson.kebele),
          employeeId: toTrimmedString(normalizedPerson.employeeId),
          licenseNumber: toTrimmedString(normalizedPerson.licenseNumber),
          prefix: prefixValue,
          unemployed: isUnemployed,
          cat2Role: cat2Role || null,
          cat2Multiplier: roleRequirement?.multiplier || null,
          cat2MultiplierValue: cat2MultiplierValue,
          ceu: rowCeu,
          woredaId: resolvedWoredaId || null,
          facilityId: facilityObj?.id || null,
          regionId: resolvedRegionId || null,
          locationId: resolvedRegionId || null,
          professionId: professionId || null,
          healthProfessionId: professionId || null,
        };
      });

      if (errors.length > 0) {
        errors.forEach((err) => {
          errorRows[err.row] = errorRows[err.row] || [];
          errorRows[err.row].push(err.message);
        });
      }

      return {
        mappedTrainees,
        previewRows,
        errors: errors.map((e) => e.message),
        errorRows,
        errorDetails,
      };
    },
    onTraineeEdit() {
      this.revalidateTrainees();
    },
    revalidateTrainees() {
      const {mappedTrainees, previewRows, errors, errorRows, errorDetails} = this.mapTraineeRows(this.csvResults);
      this.importedData = mappedTrainees;
      this.csvResults = previewRows;
      this.traineeErrorList = errors;
      this.traineeErrorDetails = errorDetails;
      this.importErrors = errorRows;
      this.importErrorsDialog = errors.length > 0;
    },
    traineeFieldLabel(field) {
      const labels = {
        prefix: "Prefix",
        firstName: "First Name",
        fatherName: "Father Name",
        grandfatherName: "Grandfather Name",
        gender: "Gender",
        profession: "Profession",
        region: "Region",
        zone: "Zone",
        woreda: "Woreda",
        facility: "Facility",
        cat2Role: "Cat II Role",
        cat2MultiplierValue: "Multiplier Value",
        ceu: "CEU",
        kebele: "Kebele",
        unemployed: "Unemployed",
        emailAddress: "Email Address",
        phoneNumber: "Phone Number",
        employeeId: "Employee Id",
        licenseNumber: "License Number",
        nationalId: "National Id",
      };
      return labels[field] || field;
    },
    cellId(rowIndex, field) {
      return `trainee-cell-${rowIndex}-${field}`;
    },
    goToTraineeError(error) {
      const rowIndex = Math.max(0, error.row - 1);
      const itemsPerPage = Number(this.previewOptions.itemsPerPage) || 10;
      const page = Math.floor(rowIndex / itemsPerPage) + 1;
      this.previewOptions.page = page;
      this.$nextTick(() => {
        const id = this.cellId(rowIndex, error.field);
        const el = document.getElementById(id);
        if (el && el.focus) {
          el.focus();
          if (el.scrollIntoView) {
            el.scrollIntoView({behavior: "smooth", block: "center"});
          }
        }
      });
    },
    beforeUpload(file) {
      void file;
      return true;
    },
    formatDownloadTime(dateValue) {
      if (!dateValue) return "";
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString();
    },
    async downloadTemplate() {
      if (this.templateDownloadLoading) {
        this.$toast.info("Template download is already in progress.");
        return;
      }
      this.templateDownloadLoading = true;
      this.templateDownloadProgress = 2;
      this.templateDownloadMessage = "Preparing template...";
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 0));
      try {
        await this.prepareExel((progress, message) => {
          const safeProgress = Number.isFinite(Number(progress))
              ? Math.max(0, Math.min(100, Math.round(Number(progress))))
              : this.templateDownloadProgress;
          this.templateDownloadProgress = Math.max(this.templateDownloadProgress, safeProgress);
          if (message) {
            this.templateDownloadMessage = message;
          }
        });
        this.templateDownloadProgress = 100;
        this.templateDownloadMessage = "Download complete";
        this.templateDownloadedAt = new Date();
        this.$toast.success("Template downloaded successfully.");
      } catch (error) {
        console.error(error);
        this.templateDownloadProgress = 0;
        this.templateDownloadMessage = "";
        this.$toast.error("Unable to download template right now.");
      } finally {
        this.templateDownloadLoading = false;
      }
    },
    async downloadGoogleFormTemplate() {
      try {
        const workbook = new ExcelJS.Workbook();
        const instructionSheet = workbook.addWorksheet("Instructions");
        const questionSheet = workbook.addWorksheet("Google Form Questions");
        const exportSheet = workbook.addWorksheet("Google Export Columns");
        const dropdownSheet = workbook.addWorksheet("Dropdown Lists");
        const mfrSheet = workbook.addWorksheet("MFR Hierarchy");
        const apiSheet = workbook.addWorksheet("Public API Endpoints");
        const appsScriptSheet = workbook.addWorksheet("Apps Script Template");
        const {
          regions: scopedRegions,
          zones: scopedZones,
          woredas: scopedWoredas,
          facilities: scopedFacilities,
          providers: scopedProviders,
        } = this.getTemplateScopedLookups();
        const sampleRegionName = this.toTrimmedString(scopedRegions?.[0]?.name) || "Addis Ababa";
        const sampleZoneName = this.toTrimmedString(scopedZones?.[0]?.name) || "Bole";
        const sampleWoredaName = this.toTrimmedString(scopedWoredas?.[0]?.name) || "Bole";
        const sampleFacilityName = this.toTrimmedString(scopedFacilities?.[0]?.name) || "Bole Health Center";

        instructionSheet.addRow(["How to use this Google Form template"]);
        instructionSheet.addRow(["1. Create a new Google Form."]);
        instructionSheet.addRow(["2. Add questions using the exact titles from the 'Google Export Columns' sheet (except Timestamp)."]);
        instructionSheet.addRow(["3. Use question types/options from 'Google Form Questions'."]);
        instructionSheet.addRow(["4. Copy values from 'Dropdown Lists' into Google Form dropdown questions."]);
        instructionSheet.addRow(["5. Optional: sync dropdown values from public MFR APIs (see 'Public API Endpoints')."]);
        instructionSheet.addRow(["6. Share the form link with trainees and collect responses."]);
        instructionSheet.addRow(["7. Export Google Form responses to Excel (.xlsx) or CSV and upload here in Step 1."]);
        instructionSheet.addRow(["8. Complete CPD Activity details in Step 2, then continue import."]);
        instructionSheet.getColumn(1).width = 120;

        questionSheet.addRow(["Question Title", "Question Type", "Required", "Options / Format", "Maps To"]);
        const questionRows = [
          ["Prefix", "Dropdown", "No", "Ato (Mr); W/ro (Mrs); W/rt (Ms); DR", "prefix"],
          ["First Name", "Short answer", "Yes", "Text", "firstName"],
          ["Father Name", "Short answer", "Yes", "Text", "fatherName"],
          ["Grandfather Name", "Short answer", "Yes", "Text", "grandfatherName"],
          ["Gender", "Dropdown", "Yes", "Male; Female", "gender"],
          ["Profession", "Dropdown", "Yes", "Must match HRD profession list", "profession"],
          ["Region", "Dropdown", "Yes", "Must match HRD region list", "region"],
          ["Zone", "Dropdown", "No", "Must match HRD zone list", "zone"],
          ["Woreda", "Dropdown", "No", "Must match HRD woreda list", "woreda"],
          ["Facility", "Dropdown", "Conditional", "Required when Unemployed is No", "facility"],
          ...(!this.isCategory1Import ? [
            ["Cat II Role", "Dropdown", "Yes", "Must match Cat II role values", "cat2Role"],
            ["Multiplier Value", "Short answer", "Conditional", "Required if selected Cat II role needs multiplier", "cat2MultiplierValue"],
          ] : []),
          ["Kebele", "Short answer", "No", "Text", "kebele"],
          ["Unemployed", "Dropdown", "Yes", "Yes; No", "unemployed"],
          ["Email Address", "Short answer", "No", "Valid email when supplied", "emailAddress"],
          ["Phone Number", "Short answer", "Yes", "Format: +2519xxxxxxx or +2517xxxxxxx", "phoneNumber"],
          ["Employee Id", "Short answer", "No", "Text", "employeeId"],
          ["License Number", "Short answer", "No", "Text", "licenseNumber"],
          ["National Id", "Short answer", "No", "Text", "nationalId"],
        ];
        questionRows.forEach((row) => questionSheet.addRow(row));
        [34, 18, 12, 52, 24].forEach((width, index) => {
          questionSheet.getColumn(index + 1).width = width;
        });

        const exportHeaders = [
          "Timestamp",
          "Prefix",
          "First Name",
          "Father Name",
          "Grandfather Name",
          "Gender",
          "Profession",
          "Region",
          "Zone",
          "Woreda",
          "Facility",
          ...(!this.isCategory1Import ? ["Cat II Role", "Multiplier Value"] : []),
          "Kebele",
          "Unemployed",
          "Email Address",
          "Phone Number",
          "Employee Id",
          "License Number",
          "National Id",
        ];
        exportSheet.addRow(exportHeaders);
        exportSheet.addRow([
          "2026-01-01 08:00:00",
          "Ato (Mr)",
          "Abebe",
          "Kebede",
          "Bekele",
          "Male",
          this.toTrimmedString(this.PROFESSIONS?.[0]?.name) || "Nurse",
          sampleRegionName,
          sampleZoneName,
          sampleWoredaName,
          sampleFacilityName,
          ...(!this.isCategory1Import ? ["Trainee", ""] : []),
          "Kebele 01",
          "No",
          "abebe@example.com",
          "+251912345678",
          "EMP-1001",
          "LIC-1001",
          "NID-1001",
        ]);
        exportHeaders.forEach((_, index) => {
          exportSheet.getColumn(index + 1).width = 20;
        });

        const uniqueValues = (values = []) => {
          const seen = new Set();
          const output = [];
          values.forEach((value) => {
            const cleaned = this.toTrimmedString(value);
            if (!cleaned) return;
            const key = cleaned.toLowerCase();
            if (seen.has(key)) return;
            seen.add(key);
            output.push(cleaned);
          });
          return output;
        };

        let allCatIIRoles = [];
        try {
          const cat2RequirementsPayload = this.isCategory1Import ? [] : await getCatIIRequirements();
          const cat2Rows = this.extractRows(cat2RequirementsPayload);
          allCatIIRoles = uniqueValues((Array.isArray(cat2Rows) ? cat2Rows : []).map((item) => item?.role));
        } catch (error) {
          allCatIIRoles = uniqueValues((this.activityCatIIRequirements || []).map((item) => item?.role));
        }
        if (!this.isCategory1Import) exportSheet.getCell("L2").value =
            allCatIIRoles[0] || exportSheet.getCell("L2").value;

        const dropdownGroups = {
          Prefix: uniqueValues((this.prefixes || []).map((item) => item?.name)),
          Gender: ["Male", "Female"],
          Unemployed: ["Yes", "No"],
          Profession: uniqueValues((this.PROFESSIONS || []).map((item) => item?.name)),
          Region: uniqueValues((scopedRegions || []).map((item) => item?.name)),
          Zone: uniqueValues((scopedZones || []).map((item) => item?.name)),
          Woreda: uniqueValues((scopedWoredas || []).map((item) => item?.name)),
          Facility: uniqueValues((scopedFacilities || []).map((item) => item?.name)),
          ...(!this.isCategory1Import ? {"Cat II Role": allCatIIRoles} : {}),
          "CPD Activity Type": uniqueValues((this.PROGRAM_TYPES || []).map((item) => item?.name)),
          [`CPD Category (${this.importCategoryType})`]: uniqueValues(this.importCategories.map((item) => item?.name)),
          "Funded By": uniqueValues((this.FUNDED_BY || []).map((item) => item?.name)),
          "CPD Provider": uniqueValues((scopedProviders || []).map((item) => item?.trainingCenterName)),
        };

        const dropdownHeaders = Object.keys(dropdownGroups);
        dropdownSheet.addRow(dropdownHeaders);
        const dropdownMax = Math.max(
            0,
            ...dropdownHeaders.map((header) => (dropdownGroups[header] || []).length)
        );
        for (let rowIndex = 0; rowIndex < dropdownMax; rowIndex += 1) {
          const row = dropdownHeaders.map((header) => (dropdownGroups[header] || [])[rowIndex] || "");
          dropdownSheet.addRow(row);
        }
        dropdownHeaders.forEach((header, index) => {
          dropdownSheet.getColumn(index + 1).width = Math.max(20, header.length + 4);
        });

        mfrSheet.addRow(["Region", "Zone", "Woreda", "Facility"]);
        const zoneById = (scopedZones || []).reduce((acc, zone) => {
          acc[Number(zone?.id)] = zone;
          return acc;
        }, {});
        const regionById = (scopedRegions || []).reduce((acc, region) => {
          acc[Number(region?.id)] = region;
          return acc;
        }, {});
        const woredaById = (scopedWoredas || []).reduce((acc, woreda) => {
          acc[Number(woreda?.id)] = woreda;
          return acc;
        }, {});

        const hierarchyRows = [];
        (scopedFacilities || []).forEach((facility) => {
          const woreda = woredaById[Number(facility?.woredaId)];
          const zone = zoneById[Number(woreda?.zoneId)];
          const region = regionById[Number(zone?.regionId)];
          hierarchyRows.push([
            this.toTrimmedString(region?.name),
            this.toTrimmedString(zone?.name),
            this.toTrimmedString(woreda?.name),
            this.toTrimmedString(facility?.name),
          ]);
        });

        hierarchyRows
            .filter((row) => row.some((cell) => this.toTrimmedString(cell)))
            .sort((a, b) => `${a[0]}|${a[1]}|${a[2]}|${a[3]}`.localeCompare(`${b[0]}|${b[1]}|${b[2]}|${b[3]}`))
            .forEach((row) => mfrSheet.addRow(row));
        [24, 24, 24, 34].forEach((width, index) => {
          mfrSheet.getColumn(index + 1).width = width;
        });

        apiSheet.addRow(["Endpoint", "Method", "Description", "Example"]);
        const apiRows = [
          ["/mfr/regions/drp", "GET", "All regions", "/mfr/regions/drp"],
          ["/mfr/zones/drp", "GET", "Zones (optional region filter)", "/mfr/zones/drp?regionId=1"],
          ["/mfr/woredas/drp", "GET", "Woredas (optional zone filter)", "/mfr/woredas/drp?zoneId=10"],
          ["/mfr/facilities/drp", "GET", "Facilities (optional woreda filter)", "/mfr/facilities/drp?woredaId=100"],
          ["/mfr/regions", "GET", "Regions with query support", "/mfr/regions?name=Addis"],
          ["/mfr/zones", "GET", "Zones with query support", "/mfr/zones?regionId=1"],
          ["/mfr/woredas", "GET", "Woredas with query support", "/mfr/woredas?zoneId=10"],
          ["/mfr/facilities", "GET", "Facilities with query support", "/mfr/facilities?woredaId=100"],
        ];
        apiRows.forEach((row) => apiSheet.addRow(row));
        [32, 10, 36, 44].forEach((width, index) => {
          apiSheet.getColumn(index + 1).width = width;
        });

        const apiBase = (this.toTrimmedString(settings?.API_SERVER) || "").replace(/\/$/, "");
        const scriptLines = [
          "// Paste this in Google Apps Script and update FORM_ID + API_BASE_URL",
          "const FORM_ID = 'REPLACE_WITH_FORM_ID';",
          `const API_BASE_URL = '${apiBase}';`,
          "",
          "function fetchJson(path) {",
          "  const response = UrlFetchApp.fetch(`${API_BASE_URL}${path}`);",
          "  return JSON.parse(response.getContentText());",
          "}",
          "",
          "function setDropdownChoices(itemTitle, values) {",
          "  const form = FormApp.openById(FORM_ID);",
          "  const item = form.getItems(FormApp.ItemType.LIST).find(i => i.getTitle() === itemTitle);",
          "  if (!item) return;",
          "  const choices = [...new Set(values.filter(Boolean))].map(v => item.asListItem().createChoice(v));",
          "  if (choices.length) item.asListItem().setChoices(choices);",
          "}",
          "",
          "function syncRegionChoices() {",
          "  const regions = fetchJson('/mfr/regions/drp');",
          "  setDropdownChoices('Region', regions.map(r => r.name));",
          "}",
          "",
          "function syncZoneChoices(regionId) {",
          "  const zones = fetchJson(`/mfr/zones/drp?regionId=${regionId}`);",
          "  setDropdownChoices('Zone', zones.map(z => z.name));",
          "}",
          "",
          "// Repeat similar functions for /mfr/woredas/drp and /mfr/facilities/drp",
        ];
        appsScriptSheet.addRow(["Google Apps Script"]);
        scriptLines.forEach((line) => appsScriptSheet.addRow([line]));
        appsScriptSheet.getColumn(1).width = 120;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, this.isCategory1Import ? "cat1_google_form_template.xlsx" : "cpd_google_form_template.xlsx");
        this.$toast.success("Google Form template downloaded successfully.");
      } catch (error) {
        console.error(error);
        this.$toast.error("Unable to download Google Form template right now.");
      }
    },
    async processBulkImport() {
      if (this.bulkImportLoading || this.bulkImportedUpdates.length) return;
      this.validateActivityForm();
      if (this.hasTraineeErrors || this.hasActivityErrors || !this.isCompletionValid) {
        this.$toast.error("Please fix all validation errors before proceeding.");
        return;
      }
      this.bulkImportLoading = true;
      this.bulkImportMessage = "";
      this.bulkImportErrors = [];
      this.bulkImportWarnings = [];
      this.bulkImportWarningsDialog = false;
      this.bulkImportedUpdates = [];
      this.bulkCertificateErrors = [];
      this.bulkProgress = {total: 0, current: 0};

      try {
        const defaultRequirement = this.getCatIIRequirementByRole(
            this.traineeDefaults.cat2Role
        );
        const defaultMultiplierValue = this.toNumberValue(
            this.traineeDefaults.cat2MultiplierValue
        );
        const defaultCeu = this.calculateCat2Ceu(
            defaultRequirement,
            defaultMultiplierValue
        );
        const payload = {
          trainees: this.importedData,
          cpdActivity: {
            ...this.importActivity,
            cat2RequirementId: defaultRequirement?.id ?? null,
            cat2Role: defaultRequirement?.role || null,
            cat2Multiplier: defaultRequirement?.multiplier || null,
            cat2MultiplierValue: defaultRequirement?.multiplier
                ? defaultMultiplierValue
                : null,
            ceu: defaultCeu,
          },
          ...(!this.isCategory1Import ? {completion: {
            courseCompletionDate: this.completion.courseCompletionDate,
            certificateReasonId: this.completion.certificateReason,
          }} : {}),
        };

        if (this.isCategory1Import) {
          // Send registration and assignment data only for Category I.
          ["cat2RequirementId", "cat2Role", "cat2Multiplier", "cat2MultiplierValue", "ceu", "courseTitleCat2"].forEach((key) => delete payload.cpdActivity[key]);
          payload.trainees = payload.trainees.map((trainee) => {
            const result = {...trainee};
            ["cat2Role", "cat2Multiplier", "cat2MultiplierValue", "ceu"].forEach((key) => delete result[key]);
            return result;
          });
        }
        const res = await TraineeService.bulkImportCpdTrainees(payload);
        if (res.status === 200 || res.status === 201) {
          const importResult = res?.data || {};
          const updates = Array.isArray(importResult?.updates)
              ? importResult.updates
              : [];
          this.bulkImportedUpdates = updates;
          this.bulkImportErrors = Array.isArray(importResult?.errors)
              ? importResult.errors
              : [];
          this.bulkImportWarnings = Array.isArray(importResult?.warnings)
              ? importResult.warnings
              : [];
          this.bulkProgress.total = updates.length;
          this.bulkProgress.current = updates.length;
          if (updates.length > 0) {
            this.$toast.info(this.isCategory1Import
                ? "Trainees registered and assigned. Continue on New Trainees Courses to score, complete, approve and generate certificates."
                : "Bulk import completed. Certificates can be printed after every imported trainee is approved.");
          }
          if (this.bulkImportWarnings.length > 0) {
            this.bulkImportWarningsDialog = true;
          }
          this.bulkImportMessage = res.message || "Bulk import completed successfully!";
        } else {
          this.bulkImportErrors = Array.isArray(res?.data) ? res.data : [];
          this.$toast.error(res.message || "Unable to process bulk import.");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Unable to process bulk import.");
      } finally {
        this.bulkImportLoading = false;
      }
    },
    async generateCertificatesBatch(updates, mode = "download") {
      if (this.isCategory1Import) return;
      if (!updates.length) return;
      if (this.bulkCertificateLoading) return;
      const pendingApprovalCount = updates.filter(
          (update) => !this.isImportedCertificateApproved(update)
      ).length;
      if (pendingApprovalCount > 0) {
        const message = `${pendingApprovalCount} imported trainee certificate(s) still require approval. Approve all trainees before printing or emailing certificates.`;
        this.bulkCertificateErrors = [message];
        this.$toast.warning(message);
        return;
      }
      this.bulkCertificateLoading = true;
      this.bulkCertificateErrors = [];
      this.bulkProgress = {total: updates.length, current: 0};
      const shouldEmail = mode === "email";
      const zip = shouldEmail ? null : new JSZip();
      let certificateCount = 0;
      const flushUi = async () => {
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 0));
      };

      try {
        for (let i = 0; i < updates.length; i++) {
          const update = updates[i];
          const courseDetail = update?.newt_cat2_course || update?.newt_cat2_courses || update?.new_trainees_course;
          if (!courseDetail) {
            this.bulkCertificateErrors.push("Some imported trainees are missing course details.");
            this.bulkProgress.current += 1;
            await flushUi();
            continue;
          }
          if (shouldEmail && !resolveCertificateEmail(update)) {
            this.bulkCertificateErrors.push("Some imported trainees are missing email and were skipped.");
            this.bulkProgress.current += 1;
            await flushUi();
            continue;
          }
          try {
            const url = settings.FRONT_URL + "newTraineeInformation/" + update.id;
            const qrRes = await TraineeService.generateQrCode({url});
            const qrImage = qrRes?.data?.data || qrRes?.data;
            if (shouldEmail) {
              await generateCertificate1(courseDetail, update, qrImage, {
                open: false,
                sendEmail: true,
                returnBlob: false,
              });
              certificateCount += 1;
            } else {
              const pdfBlob = await generateCertificate1(courseDetail, update, qrImage, {
                open: false,
                sendEmail: false,
                returnBlob: true,
              });
              if (!pdfBlob) {
                this.bulkCertificateErrors.push("Some certificates failed to process.");
                this.bulkProgress.current += 1;
                await flushUi();
                continue;
              }
              const fileName = this.safeFileName(update, courseDetail);
              zip.file(fileName, pdfBlob);
              certificateCount += 1;
            }
          } catch (error) {
            console.error(error);
            this.bulkCertificateErrors.push("Some certificates failed to process.");
          }
          this.bulkProgress.current += 1;
          await flushUi();
        }

        if (!certificateCount) {
          this.$toast.error(shouldEmail ? "No certificates were emailed." : "No certificates were generated.");
          return;
        }

        if (shouldEmail) {
          this.$toast.success(`${certificateCount} certificate(s) generated and emailed.`);
        } else {
          const zipBlob = await zip.generateAsync({type: "blob"});
          saveAs(zipBlob, `trainee_certificates_${new Date().toISOString().slice(0, 10)}.zip`);
          this.$toast.success(`${certificateCount} certificate(s) generated.`);
        }
      } finally {
        this.bulkCertificateLoading = false;
      }
    },
    getImportedCourseDetail(update) {
      return update?.newt_cat2_course ||
          update?.newt_cat2_courses ||
          update?.new_trainees_course ||
          null;
    },
    isImportedCertificateApproved(update) {
      const courseDetail = this.getImportedCourseDetail(update);
      return Boolean(courseDetail?.certificateApprovalStatus) &&
          isCertificateApprovalComplete(courseDetail);
    },
    safeFileName(update, courseDetail) {
      const name = update?.trainee
          ? `${update.trainee.firstName || ""} ${update.trainee.middleName || ""} ${update.trainee.lastName || ""}`
          : "trainee";
      const course = courseDetail?.course?.courseName || courseDetail?.program?.courseTitleCat2 || "certificate";
      return `${name}-${course}`.replace(/[^a-zA-Z0-9-_]+/g, "_").slice(0, 80) + ".pdf";
    },
    async prepareExel(onProgress = null) {
      const flushUi = async () => {
        await this.$nextTick();
        await new Promise((resolve) => setTimeout(resolve, 0));
      };
      const notifyProgress = (value, message = "") => {
        if (typeof onProgress === "function") {
          onProgress(value, message);
        }
      };
      notifyProgress(5, "Preparing workbook...");
      await flushUi();
      const workbook = new ExcelJS.Workbook();
      const instructionSheet = workbook.addWorksheet('Instructions');
      const lookupSheet = workbook.addWorksheet('Lookups');
      const activitySheet = workbook.addWorksheet('CPD Activity');
      const completionSheet = this.isCategory1Import ? null : workbook.addWorksheet('Completion');
      const traineeSheet = workbook.addWorksheet('Trainees');
      const {
        regions: scopedRegions,
        zones: scopedZones,
        woredas: scopedWoredas,
        facilities: scopedFacilities,
        providers: scopedProviders,
      } = this.getTemplateScopedLookups();
      lookupSheet.state = 'veryHidden';
      instructionSheet.addRow(['How to use this bulk import template']);
      instructionSheet.addRow(['1. Fill the CPD Activity sheet first.']);
      instructionSheet.addRow(['2. Add one trainee per row in the Trainees sheet.']);
      instructionSheet.addRow([this.isCategory1Import
          ? '3. Select an existing course, course level and activity delivery. Score, complete, approve and generate certificates on New Trainees Courses after import.'
          : '3. Fill the Completion sheet with the completion date and certificate reason.']);
      instructionSheet.addRow(['4. Use the provided dropdown values where available.']);
      instructionSheet.addRow(['5. Red headers are required; dark grey headers are optional.']);
      instructionSheet.addRow(['6. Replace the sample rows with real data before uploading.']);
      instructionSheet.getColumn(1).width = 90;

      const limitList = (items, limit = null) => {
        if (!Array.isArray(items)) return [];
        const unique = Array.from(new Set(items.filter((value) => value !== null && value !== undefined)));
        if (typeof limit === "number" && Number.isFinite(limit) && limit > 0) {
          return unique.slice(0, limit);
        }
        return unique;
      };

      const addLookupList = (header, values, column) => {
        lookupSheet.getCell(`${column}1`).value = header;
        const items = limitList(values);
        items.forEach((value, index) => {
          lookupSheet.getCell(`${column}${index + 2}`).value = value;
        });
        if (!items.length) return null;
        return `'Lookups'!$${column}$2:$${column}$${items.length + 1}`;
      };
      const styleHeaders = (sheet, headers, requiredHeaders) => {
        const required = new Set(requiredHeaders);
        headers.forEach((header, index) => {
          const cell = sheet.getCell(1, index + 1);
          cell.font = {bold: true, color: {argb: "FFFFFFFF"}};
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: required.has(header) ? "FFC62828" : "FF455A64",
            },
          };
          cell.alignment = {vertical: "middle", horizontal: "center"};
          cell.note = required.has(header)
              ? `${header} is required.`
              : `${header} is optional unless the form rules make it conditional.`;
        });
        sheet.getRow(1).height = 28;
      };

      notifyProgress(14, "Loading lookup values...");
      await flushUi();
      const programTypeRange = addLookupList(
          'Program Types',
          this.PROGRAM_TYPES.map((data) => data.name),
          'A'
      );
      const categoryRange = addLookupList(
          'CPD Categories',
          this.importCategories.map((data) => data.name),
          'B'
      );
      const fundedByRange = addLookupList(
          'Funded By',
          this.FUNDED_BY.map((data) => data.name),
          'C'
      );
      const professionRange = addLookupList(
          'Professions',
          this.PROFESSIONS.map((data) => data.name),
          'D'
      );
      const regionRange = addLookupList(
          'Regions',
          scopedRegions.map((data) => data.name),
          'E'
      );
      const prefixRange = addLookupList(
          'Prefixes',
          ["Ato (Mr)", "W/ro (Mrs)", "W/rt (Ms)", "DR"],
          'F'
      );
      const genderRange = addLookupList(
          'Gender',
          ["Male", "Female"],
          'G'
      );
      const unemployedRange = addLookupList(
          'Unemployed',
          ["Yes", "No"],
          'H'
      );
      const colorRange = addLookupList(
          'Color Codes',
          [
            "#131414FF",
            "#1976d2",
            "#1565c0",
            "#2e7d32",
            "#ef6c00",
            "#c62828",
            "#6a1b9a",
            "#00838f",
            "#f9a825",
            "#546e7a",
          ],
          'I'
      );
      let cat2RoleRange = null;
      let templateCat2Roles = [];
      try {
        const cat2RequirementsPayload = this.isCategory1Import ? [] : await getCatIIRequirements();
        const cat2RequirementsRows = this.extractRows(cat2RequirementsPayload);
        templateCat2Roles = (Array.isArray(cat2RequirementsRows) ? cat2RequirementsRows : [])
            .map((item) => this.toTrimmedString(item?.role))
            .filter((item) => item);
        cat2RoleRange = addLookupList(
            'Cat II Roles',
            templateCat2Roles,
            'J'
        );
      } catch (error) {
        templateCat2Roles = (this.activityCatIIRequirements || [])
            .map((item) => this.toTrimmedString(item?.role))
            .filter((item) => item);
        cat2RoleRange = null;
      }
      const collaboratorRange = addLookupList(
          'Collaborator',
          this.COLLABORATOR_OPTIONS,
          'K'
      );
      addLookupList('Zones', scopedZones.map((data) => data.name), 'L');
      addLookupList('Woredas', scopedWoredas.map((data) => data.name), 'M');
      addLookupList(
          'Facilities',
          scopedFacilities.map((data) => this.getFacilityDisplayText(data)),
          'N'
      );
      const cpdProviderRange = addLookupList(
          'CPD Providers',
          (scopedProviders || [])
              .map((data) => this.toTrimmedString(data?.trainingCenterName))
              .filter((name) => name),
          'O'
      );
      const certificateReasonRange = addLookupList(
          'Certificate Reasons',
          this.CERTIFICATE_REASONS
              .map((data) => this.toTrimmedString(data?.name))
              .filter((name) => name),
          'AD'
      );

      const courseRange = this.isCategory1Import ? addLookupList('Category I Courses', this.COURSES.map(this.courseDisplayName), 'AE') : null;
      const levelRange = this.isCategory1Import ? addLookupList('Course Levels', this.COURSES.flatMap((course) => this.getImportCourseLevels(course).map((level) => level.name)), 'AF') : null;
      const deliveryRange = this.isCategory1Import ? addLookupList('Activity Deliveries', this.ACTIVITY_DELIVERIES.map((item) => item.name), 'AG') : null;

      lookupSheet.getColumn('A').width = 26;
      lookupSheet.getColumn('B').width = 26;
      lookupSheet.getColumn('C').width = 22;
      lookupSheet.getColumn('D').width = 26;
      lookupSheet.getColumn('E').width = 20;
      lookupSheet.getColumn('F').width = 18;
      lookupSheet.getColumn('G').width = 12;
      lookupSheet.getColumn('H').width = 16;
      lookupSheet.getColumn('I').width = 14;
      lookupSheet.getColumn('J').width = 28;
      lookupSheet.getColumn('K').width = 28;
      lookupSheet.getColumn('L').width = 28;
      lookupSheet.getColumn('M').width = 28;
      lookupSheet.getColumn('N').width = 34;
      lookupSheet.getColumn('O').width = 34;

      const ensureNamedRange = (name, ref) => {
        try {
          // ExcelJS expects add(rangeRef, definedName)
          workbook.definedNames.add(ref, name);
        } catch (error) {
          // Ignore duplicate definition errors for regenerated templates.
        }
      };

      lookupSheet.getCell('Z1').value = '';
      ensureNamedRange('EMPTY_LIST', `'Lookups'!$Z$1:$Z$1`);

      lookupSheet.getCell('Q1').value = 'RegionToZone';
      lookupSheet.getCell('S1').value = 'RegionZoneToWoreda';
      lookupSheet.getCell('U1').value = 'RegionZoneWoredaToFacility';
      lookupSheet.getColumn('Q').width = 26;
      lookupSheet.getColumn('R').width = 20;
      lookupSheet.getColumn('S').width = 26;
      lookupSheet.getColumn('T').width = 20;
      lookupSheet.getColumn('U').width = 30;
      lookupSheet.getColumn('V').width = 20;

      let regionMapRow = 2;
      let zoneMapRow = 2;
      let woredaMapRow = 2;
      let zoneCursor = 2;
      let woredaCursor = 2;
      let facilityCursor = 2;
      const regionNameById = scopedRegions.reduce((acc, region) => {
        const regionName = this.toTrimmedString(region?.name);
        if (regionName) {
          acc[Number(region?.id)] = regionName;
        }
        return acc;
      }, {});
      const zonesById = scopedZones.reduce((acc, zone) => {
        acc[Number(zone?.id)] = zone;
        return acc;
      }, {});
      const woredasByZoneId = scopedWoredas.reduce((acc, woreda) => {
        const zoneId = Number(woreda?.zoneId);
        const woredaName = this.toTrimmedString(woreda?.name);
        if (!woredaName) return acc;
        acc[zoneId] = acc[zoneId] || [];
        acc[zoneId].push(woredaName);
        return acc;
      }, {});
      const facilitiesByWoredaId = scopedFacilities.reduce((acc, facility) => {
        const woredaId = Number(facility?.woredaId);
        const facilityName = this.toTrimmedString(facility?.name);
        if (!facilityName) return acc;
        acc[woredaId] = acc[woredaId] || [];
        acc[woredaId].push(facilityName);
        return acc;
      }, {});
      const hierarchyTotal = (scopedRegions?.length || 0) + (scopedZones?.length || 0) + (scopedWoredas?.length || 0);
      let hierarchyDone = 0;
      const updateHierarchyProgress = () => {
        if (!hierarchyTotal) {
          notifyProgress(60, "Building location mappings...");
          return;
        }
        const percent = 24 + ((hierarchyDone / hierarchyTotal) * 42);
        notifyProgress(percent, "Building location mappings...");
      };

      let processed = 0;
      for (const region of scopedRegions) {
        const regionName = this.toTrimmedString(region?.name);
        if (!regionName) continue;
        const zones = this.uniqueStringList(scopedZones
            .filter((zone) => Number(zone?.regionId) === Number(region.id))
            .map((zone) => this.toTrimmedString(zone?.name))
            .filter((name) => name));
        if (!zones.length) continue;
        const rangeName = `RG_${region.id}`;
        zones.forEach((zoneName, index) => {
          lookupSheet.getCell(`AA${zoneCursor + index}`).value = zoneName;
        });
        const zoneStart = zoneCursor;
        const zoneEnd = zoneCursor + zones.length - 1;
        ensureNamedRange(rangeName, `'Lookups'!$AA$${zoneStart}:$AA$${zoneEnd}`);
        lookupSheet.getCell(`Q${regionMapRow}`).value = regionName;
        lookupSheet.getCell(`R${regionMapRow}`).value = rangeName;
        regionMapRow += 1;
        zoneCursor = zoneEnd + 1;
        hierarchyDone += 1;
        updateHierarchyProgress();
        processed += 1;
        if (processed % 25 === 0) {
          await flushUi();
        }
      }

      processed = 0;
      const zoneKeyToWoredas = new Map();
      scopedZones.forEach((zone) => {
        const zoneName = this.toTrimmedString(zone?.name);
        const regionName = this.toTrimmedString(regionNameById[Number(zone?.regionId)]);
        if (!zoneName || !regionName) return;
        const zoneKey = `${regionName}|${zoneName}`;
        const woredas = woredasByZoneId[Number(zone?.id)] || [];
        if (!woredas.length) return;
        const existing = zoneKeyToWoredas.get(zoneKey) || [];
        zoneKeyToWoredas.set(zoneKey, existing.concat(woredas));
      });
      for (const [zoneKey, woredaValues] of zoneKeyToWoredas.entries()) {
        const woredas = this.uniqueStringList(woredaValues);
        if (!woredas.length) continue;
        const rangeName = `ZN_${zoneMapRow}`;
        woredas.forEach((woredaName, index) => {
          lookupSheet.getCell(`AB${woredaCursor + index}`).value = woredaName;
        });
        const woredaStart = woredaCursor;
        const woredaEnd = woredaCursor + woredas.length - 1;
        ensureNamedRange(rangeName, `'Lookups'!$AB$${woredaStart}:$AB$${woredaEnd}`);
        lookupSheet.getCell(`S${zoneMapRow}`).value = zoneKey;
        lookupSheet.getCell(`T${zoneMapRow}`).value = rangeName;
        zoneMapRow += 1;
        woredaCursor = woredaEnd + 1;
        hierarchyDone += 1;
        updateHierarchyProgress();
        processed += 1;
        if (processed % 25 === 0) {
          await flushUi();
        }
      }

      processed = 0;
      const woredaKeyToFacilities = new Map();
      scopedWoredas.forEach((woreda) => {
        const woredaName = this.toTrimmedString(woreda?.name);
        const zone = zonesById[Number(woreda?.zoneId)];
        const zoneName = this.toTrimmedString(zone?.name);
        const regionName = this.toTrimmedString(regionNameById[Number(zone?.regionId)]);
        if (!woredaName || !zoneName || !regionName) return;
        const woredaKey = `${regionName}|${zoneName}|${woredaName}`;
        const facilities = facilitiesByWoredaId[Number(woreda?.id)] || [];
        if (!facilities.length) return;
        const existing = woredaKeyToFacilities.get(woredaKey) || [];
        woredaKeyToFacilities.set(woredaKey, existing.concat(facilities));
      });
      for (const [woredaKey, facilityValues] of woredaKeyToFacilities.entries()) {
        const facilities = this.uniqueStringList(facilityValues);
        if (!facilities.length) continue;
        const rangeName = `WD_${woredaMapRow}`;
        facilities.forEach((facilityName, index) => {
          lookupSheet.getCell(`AC${facilityCursor + index}`).value = facilityName;
        });
        const facilityStart = facilityCursor;
        const facilityEnd = facilityCursor + facilities.length - 1;
        ensureNamedRange(rangeName, `'Lookups'!$AC$${facilityStart}:$AC$${facilityEnd}`);
        lookupSheet.getCell(`U${woredaMapRow}`).value = woredaKey;
        lookupSheet.getCell(`V${woredaMapRow}`).value = rangeName;
        woredaMapRow += 1;
        facilityCursor = facilityEnd + 1;
        hierarchyDone += 1;
        updateHierarchyProgress();
        processed += 1;
        if (processed % 25 === 0) {
          await flushUi();
        }
      }
      await flushUi();

      notifyProgress(72, "Applying activity sheet validations...");
      await flushUi();
      const activityHeaders = [
        "programType",
        "category",
        "cpdProvider",
        "courseTitle",
        "Hosting Institution",
        "participantsNumber",
        "startDate",
        "endDate",
        "Funded By:",
        "totalCost",
        "color",
        "expectedOutcome",
        "collaborator",
        ...(this.isCategory1Import ? ["courseLevel", "activityDelivery"] : []),
      ];
      activitySheet.addRow(activityHeaders);
      activitySheet.getColumn(1).width = 20;
      activitySheet.getColumn(2).width = 22;
      activitySheet.getColumn(3).width = 28;
      activitySheet.getColumn(4).width = 30;
      activitySheet.getColumn(5).width = 22;
      activitySheet.getColumn(6).width = 18;
      activitySheet.getColumn(7).width = 14;
      activitySheet.getColumn(8).width = 14;
      activitySheet.getColumn(9).width = 20;
      activitySheet.getColumn(10).width = 12;
      activitySheet.getColumn(11).width = 14;
      activitySheet.getColumn(12).width = 28;
      activitySheet.getColumn(13).width = 24;
      activitySheet.getColumn(7).numFmt = "yyyy-mm-dd";
      activitySheet.getColumn(8).numFmt = "yyyy-mm-dd";
      const templateDate = new Date();
      const templateDateString = [
        templateDate.getFullYear(),
        String(templateDate.getMonth() + 1).padStart(2, "0"),
        String(templateDate.getDate()).padStart(2, "0"),
      ].join("-");
      activitySheet.addRow([
        this.toTrimmedString(this.PROGRAM_TYPES?.[0]?.name) || "Workshop",
        this.toTrimmedString(this.importCategories?.[0]?.name) || "Sample Category",
        this.toTrimmedString(scopedProviders?.[0]?.trainingCenterName) || "",
        this.isCategory1Import ? this.courseDisplayName(this.COURSES[0]) : "Sample CPD Activity Title",
        this.toTrimmedString(this.FACILITATED_BY_OPTIONS?.[0]) || "Sample Facilitator",
        25,
        templateDateString,
        templateDateString,
        this.toTrimmedString(this.FUNDED_BY?.[0]?.name) || "",
        0,
        "#1976d2",
        "Sample expected outcome",
        this.toTrimmedString(this.COLLABORATOR_OPTIONS?.[0]) || "",
        ...(this.isCategory1Import ? [this.getImportCourseLevels(this.COURSES[0])[0]?.name || "", this.ACTIVITY_DELIVERIES[0]?.name || ""] : []),
      ]);
      if (this.isCategory1Import) {
        activitySheet.getColumn(14).width = 24;
        activitySheet.getColumn(15).width = 24;
        for (const [column, range] of [['D', courseRange], ['N', levelRange], ['O', deliveryRange]]) {
          if (range) activitySheet.dataValidations.add(`${column}2:${column}2`, {
            type: 'list', allowBlank: false, formulae: [range], showErrorMessage: true,
            error: 'Select a value from the dropdown',
          });
        }
      }

      if (programTypeRange) {
        activitySheet.dataValidations.add('A2:A2', {
          type: 'list',
          allowBlank: false,
          formulae: [programTypeRange],
        });
      }
      if (categoryRange) {
        activitySheet.dataValidations.add('B2:B2', {
          type: 'list',
          allowBlank: false,
          formulae: [categoryRange],
        });
      }
      if (cpdProviderRange) {
        activitySheet.dataValidations.add('C2:C2', {
          type: 'list',
          allowBlank: Boolean(this.userCpdProviderId),
          formulae: [cpdProviderRange],
        });
      }
      activitySheet.dataValidations.add('E2:E2', {
        type: 'textLength',
        operator: 'greaterThan',
        allowBlank: false,
        showErrorMessage: true,
        error: 'Facilitated by is required',
        formulae: [0],
      });
      activitySheet.dataValidations.add('F2:F2', {
        type: 'whole',
        operator: 'greaterThanOrEqual',
        allowBlank: false,
        showErrorMessage: true,
        error: 'Participants number must be at least 1',
        formulae: [1],
      });
      activitySheet.dataValidations.add('G2:G2', {
        type: 'date',
        allowBlank: false,
      });
      activitySheet.dataValidations.add('H2:H2', {
        type: 'date',
        allowBlank: false,
      });
      if (fundedByRange) {
        activitySheet.dataValidations.add('I2:I2', {
          type: 'list',
          allowBlank: false,
          formulae: [fundedByRange],
        });
      }
      activitySheet.dataValidations.add('J2:J2', {
        type: 'whole',
        operator: 'greaterThanOrEqual',
        allowBlank: false,
        showErrorMessage: true,
        error: 'Total cost must be zero or greater',
        formulae: [0],
      });
      if (colorRange) {
        activitySheet.dataValidations.add('K2:K2', {
          type: 'list',
          allowBlank: false,
          formulae: [colorRange],
        });
      }
      if (collaboratorRange) {
        activitySheet.dataValidations.add('M2:M2', {
          type: 'list',
          allowBlank: true,
          formulae: [collaboratorRange],
        });
      }
      if (!this.isCategory1Import) activitySheet.dataValidations.add('D2:D2', {
        type: 'textLength',
        operator: 'greaterThan',
        allowBlank: false,
        showErrorMessage: true,
        error: 'Course title is required',
        formulae: [0],
      });
      styleHeaders(
          activitySheet,
          activityHeaders,
          [
            "programType",
            "category",
            ...(!this.userCpdProviderId ? ["cpdProvider"] : []),
            "courseTitle",
            "Hosting Institution",
            "participantsNumber",
            "startDate",
            "endDate",
            "Funded By:",
            "totalCost",
            "color",
            ...(this.isCategory1Import ? ["courseLevel", "activityDelivery"] : []),
          ]
      );

      if (completionSheet) {
        const completionHeaders = [
          "courseCompletionDate",
          "certificateReason",
        ];
        completionSheet.addRow(completionHeaders);
        completionSheet.getColumn(1).width = 24;
        completionSheet.getColumn(1).numFmt = "yyyy-mm-dd";
        completionSheet.getColumn(2).width = 32;
        completionSheet.addRow([
          templateDateString,
          this.toTrimmedString(this.CERTIFICATE_REASONS?.[0]?.name) || "",
        ]);
        completionSheet.dataValidations.add('A2:A2', {
          type: 'date',
          allowBlank: false,
          showErrorMessage: true,
          error: 'Course completion date is required',
        });
        if (certificateReasonRange) {
          completionSheet.dataValidations.add('B2:B2', {
            type: 'list',
            allowBlank: false,
            formulae: [certificateReasonRange],
            showErrorMessage: true,
            error: 'Select a certificate reason from the dropdown',
          });
        }
        styleHeaders(completionSheet, completionHeaders, completionHeaders);
      }

      const traineeHeaders = [
        "prefix",
        "firstName",
        "fatherName",
        "grandfatherName",
        "gender",
        "profession",
        "region",
        "zone",
        "woreda",
        "facility",
        ...(!this.isCategory1Import ? ["cat2Role", "cat2MultiplierValue"] : []),
        "kebele",
        "unemployed",
        "emailAddress",
        "phoneNumber",
        "employeeId",
        "licenseNumber",
        "nationalId"
      ];
      traineeSheet.addRow(traineeHeaders);
      styleHeaders(
          traineeSheet,
          traineeHeaders,
          [
            "firstName",
            "fatherName",
            "grandfatherName",
            "gender",
            "profession",
            "region",
            ...(!this.isCategory1Import ? ["cat2Role"] : []),
            "unemployed",
            "phoneNumber",
          ]
      );
      traineeSheet.getCell("J1").note =
          "Facility is required when Unemployed is No.";
      traineeHeaders.forEach((header, index) => {
        traineeSheet.getColumn(index + 1).width = ["facility", "emailAddress", "profession"].includes(header) ? 28 : 18;
        if (["phoneNumber", "nationalId"].includes(header)) traineeSheet.getColumn(index + 1).numFmt = "@";
      });
      const sampleRegion = scopedRegions?.[0] || null;
      const sampleZone = scopedZones.find(
          (zone) => Number(zone?.regionId) === Number(sampleRegion?.id)
      ) || null;
      const sampleWoreda = scopedWoredas.find(
          (woreda) => Number(woreda?.zoneId) === Number(sampleZone?.id)
      ) || null;
      const sampleFacility = scopedFacilities.find(
          (facility) => Number(facility?.woredaId) === Number(sampleWoreda?.id)
      ) || null;
      traineeSheet.addRow([
        "Ato (Mr)",
        "Abebe",
        "Kebede",
        "Bekele",
        "Male",
        this.toTrimmedString(this.PROFESSIONS?.[0]?.name) || "",
        this.toTrimmedString(sampleRegion?.name) || "",
        this.toTrimmedString(sampleZone?.name) || "",
        this.toTrimmedString(sampleWoreda?.name) || "",
        this.toTrimmedString(sampleFacility?.name) || "",
        ...(!this.isCategory1Import ? [this.toTrimmedString(templateCat2Roles[0]) ||
            this.toTrimmedString(this.activityCatIIRequirements?.[0]?.role) || "", ""] : []),
        "Kebele 01",
        "No",
        "abebe@example.com",
        "+251912345678",
        "EMP-1001",
        "LIC-1001",
        "NID-1001",
      ]);
      const traineeValidationLastRow = 5000;
      // CAT1 omits the two Cat II columns; keep all following validation references aligned.
      const traineeColumn = (column) => this.isCategory1Import && column >= 'M'
          ? String.fromCharCode(column.charCodeAt(0) - 2) : column;
      const traineeFormula = (formula) => formula.replace(/(\$?)([M-P])(\d+)/g, (_, dollar, column, row) => `${dollar}${traineeColumn(column)}${row}`);
      const traineeRange = (column) => `${traineeColumn(column)}2:${traineeColumn(column)}${traineeValidationLastRow}`;
      if (prefixRange) {
        traineeSheet.dataValidations.add(traineeRange('A'), {
          type: 'list',
          allowBlank: true,
          formulae: [prefixRange],
        });
      }
      [
        {column: 'B', label: 'First name'},
        {column: 'C', label: 'Father name'},
        {column: 'D', label: 'Grandfather name'},
      ].forEach(({column, label}) => {
        traineeSheet.dataValidations.add(traineeRange(column), {
          type: 'custom',
          allowBlank: false,
          showErrorMessage: true,
          error: `${label} is required and must contain letters and spaces only`,
          formulae: [
            `AND(LEN(TRIM(${column}2))>0,SUMPRODUCT(--ISNUMBER(SEARCH(MID(${column}2,ROW(INDIRECT("1:"&LEN(${column}2))),1)," ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")))=LEN(${column}2))`,
          ],
        });
      });
      if (genderRange) {
        traineeSheet.dataValidations.add(traineeRange('E'), {
          type: 'list',
          allowBlank: false,
          formulae: [genderRange],
        });
      }
      if (professionRange) {
        traineeSheet.dataValidations.add(traineeRange('F'), {
          type: 'list',
          allowBlank: false,
          formulae: [professionRange],
        });
      }
      if (regionRange) {
        traineeSheet.dataValidations.add(traineeRange('G'), {
          type: 'list',
          allowBlank: false,
          formulae: [regionRange],
        });
      }
      const regionLookupLast = Math.max(2, regionMapRow - 1);
      const zoneLookupLast = Math.max(2, zoneMapRow - 1);
      const woredaLookupLast = Math.max(2, woredaMapRow - 1);

      traineeSheet.dataValidations.add(traineeRange('H'), {
        type: 'list',
        allowBlank: true,
        formulae: [`INDIRECT(IFERROR(VLOOKUP($G2,Lookups!$Q$2:$R$${regionLookupLast},2,FALSE),"EMPTY_LIST"))`],
      });
      traineeSheet.dataValidations.add(traineeRange('I'), {
        type: 'list',
        allowBlank: true,
        formulae: [`INDIRECT(IFERROR(VLOOKUP($G2&"|"&$H2,Lookups!$S$2:$T$${zoneLookupLast},2,FALSE),"EMPTY_LIST"))`],
      });
      traineeSheet.dataValidations.add(traineeRange('J'), {
        type: 'list',
        allowBlank: true,
        formulae: [`INDIRECT(IFERROR(VLOOKUP($G2&"|"&$H2&"|"&$I2,Lookups!$U$2:$V$${woredaLookupLast},2,FALSE),"EMPTY_LIST"))`],
      });
      traineeSheet.addConditionalFormatting({
        ref: traineeRange('J'),
        rules: [
          {
            type: 'expression',
            priority: 1,
            formulae: [traineeFormula('AND(LOWER($N2)="no",$J2="")')],
            style: {
              fill: {
                type: 'pattern',
                pattern: 'solid',
                bgColor: {argb: 'FFFFC7CE'},
                fgColor: {argb: 'FFFFC7CE'},
              },
            },
          },
        ],
      });
      if (!this.isCategory1Import && cat2RoleRange) {
        traineeSheet.dataValidations.add(traineeRange('K'), {
          type: 'list',
          allowBlank: false,
          formulae: [cat2RoleRange],
        });
      }
      if (!this.isCategory1Import) traineeSheet.dataValidations.add(traineeRange('L'), {
        type: 'decimal',
        operator: 'greaterThanOrEqual',
        allowBlank: true,
        showErrorMessage: true,
        error: 'Multiplier value must be zero or greater',
        formulae: [0],
      });
      if (unemployedRange) {
        traineeSheet.dataValidations.add(traineeRange('N'), {
          type: 'list',
          allowBlank: false,
          formulae: [unemployedRange],
        });
      }
      traineeSheet.dataValidations.add(traineeRange('O'), {
        type: 'custom',
        allowBlank: true,
        showErrorMessage: true,
        error: 'Enter a valid email address',
        formulae: [traineeFormula('OR(O2="",AND(ISNUMBER(SEARCH("@",O2)),ISNUMBER(SEARCH(".",O2))))')]
      });
      traineeSheet.dataValidations.add(traineeRange('P'), {
        type: 'custom',
        showErrorMessage: true,
        allowBlank: false,
        error: 'Phone number must be +251 followed by 9 or 7 and 8 digits',
        formulae: [traineeFormula('AND(OR(LEFT(P2,4)="+251",LEFT(P2,3)="251"),OR(MID(P2,IF(LEFT(P2,1)="+",5,4),1)="9",MID(P2,IF(LEFT(P2,1)="+",5,4),1)="7"),LEN(P2)=IF(LEFT(P2,1)="+",13,12),ISNUMBER(VALUE(MID(P2,IF(LEFT(P2,1)="+",5,4),9))))')]
      });
      notifyProgress(88, "Generating file...");
      await flushUi();
      const buffer = await workbook.xlsx.writeBuffer();
      notifyProgress(96, "Finalizing download...");
      await flushUi();
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, this.isCategory1Import ? 'trainee_cat1_bulk_template.xlsx' : 'trainee_cpd_bulk_template.xlsx');
      notifyProgress(100, "Download complete");
    },
  }
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.cpd-provider-form__shell {
  padding: 12px;
}

.cpd-provider-form__grid {
  margin: 12px 16px 6px;
  row-gap: 12px;
}

.cpd-provider-form__grid > div {
  margin-bottom: 0 !important;
}

.cpd-provider-form__grid br {
  display: none;
}

.cpd-provider-form__actions {
  margin: 8px 16px 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cpd-provider-form__submit {
  background: #1976d2;
  border: 1px solid #1976d2;
  color: #ffffff;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.cpd-provider-form__submit:hover {
  background: #1565c0;
  border-color: #1565c0;
}

.cpd-provider-form__back {
  background: transparent;
  border: 1px solid #1976d2;
  color: #1976d2 !important;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.cpd-provider-form__back:hover {
  background: rgba(25, 118, 210, 0.08);
}

.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.import-template-banner {
  border-radius: 12px;
  background: linear-gradient(180deg, #f3f8ff 0%, #eef5ff 100%);
}

.import-template-banner__top {
  gap: 12px;
}

.import-template-title {
  font-size: 1.08rem;
  line-height: 1.45;
  font-weight: 700;
  color: #0f3d8c;
}

.import-template-subtitle {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #334155;
  max-width: 640px;
}

.import-template-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.import-template-actions__buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.import-template-download-btn {
  font-weight: 600;
  letter-spacing: 0.2px;
}

.import-template-google-btn {
  font-weight: 600;
  letter-spacing: 0.1px;
}

.import-template-back-btn {
  font-weight: 600;
}

.import-template-note {
  font-size: 0.92rem;
  line-height: 1.45;
  color: #334155;
}

.import-template-progress {
  max-width: 460px;
}

.import-template-progress__label {
  font-size: 0.84rem;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 6px;
}

.import-template-help {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(25, 118, 210, 0.08);
  border: 1px solid rgba(25, 118, 210, 0.2);
}

.import-template-help__text {
  font-size: 0.92rem;
  line-height: 1.45;
}

.import-upload-card {
  padding: 14px;
  border-radius: 10px;
  border: 1px dashed rgba(15, 61, 140, 0.25);
  background: #ffffff;
}

.import-substeps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.import-substep {
  display: grid;
  grid-template-columns: 28px 1fr auto;
  align-items: start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #dbe7ff;
  border-radius: 10px;
  background: #ffffff;
}

.import-substep.is-done {
  border-color: #86efac;
  background: #f0fdf4;
}

.import-substep__badge {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #1e3a8a;
  background: #dbeafe;
}

.import-substep__body {
  min-width: 0;
}

.import-substep__title {
  font-size: 0.96rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
}

.import-substep__text {
  margin-top: 2px;
  font-size: 0.88rem;
  color: #475569;
  line-height: 1.4;
}

.import-substep__meta {
  margin-top: 4px;
  font-size: 0.82rem;
  font-weight: 600;
}

.bulk-import-warning-header {
  background: #fffbeb;
  display: flex;
  gap: 12px;
  align-items: center;
}

.bulk-import-warning-title {
  font-size: 22px;
  font-weight: 700;
  color: #92400e;
}

.bulk-import-warning-subtitle {
  font-size: 14px;
  color: #78350f;
  margin-top: 4px;
}

.bulk-import-warning-message {
  white-space: normal;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .import-template-title {
    font-size: 1rem;
  }

  .import-template-subtitle,
  .import-template-note,
  .import-template-help__text,
  .import-substep__text {
    font-size: 0.88rem;
  }

  .import-template-actions {
    align-items: stretch;
  }

  .import-template-actions__buttons {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .import-template-progress {
    max-width: 100%;
  }

  .import-substep {
    grid-template-columns: 24px 1fr auto;
    padding: 10px;
  }

  .import-substep__badge {
    width: 24px;
    height: 24px;
    font-size: 0.74rem;
  }
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%) !important;
}
</style>
